import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import Addresses from "./addresses.jsx";
import './styles.scss';
import DataBlock from "../../../components/DataBlock.jsx";
import Section from "../../../components/Section.jsx";
import ParcelParamsBlock from "./parcelParamsBlock.jsx";
import {Button, Checkbox, Dimmer, Form, FormField, Input, Loader as Load, Radio, Segment} from "semantic-ui-react";
import CardBlock from "../../../components/CardBlock.jsx";
import Info from "../../../components/Info.jsx";
import DatePicker from "../../../components/DatePicker/DatePicker.jsx";
import Dropdown from "../../../components/Dropdown.jsx";
import uuidv4 from "uuid/v4";
import {apiGet, apiPost, apiPut} from "../../../services/apiClient";
import {
    getCurrentUserAllCompanyIds,
    getCurrentUserCompanyId,
    getCurrentUserId,
    getCurrentUserSubCompanyId,
    getRoles
} from "../../../services/userRights";
import ConfirmModal from "../../../components/Modals/ConfirmModal.jsx";
import ru from 'react-phone-input-2/lang/ru.json';
import i18n from "../../../services/i18n";
import Logos from "./logos.jsx";
import throttle from "lodash.throttle";
import '../../../containers/style/styles.scss';
import {toast} from 'react-toastify';
import {parseDate} from "../../../services/date";
import {costFormat} from "../../../services/cost";
import {parse, startOfToday, getCurrentOrNextBusinessDay, isSameDay, formatDateISO} from "../../../services/dateUtils";
import PointAddress from "./pointAddress";
import {getEmailValidationError} from "../../../controls/semanticEmailInput";
import {splitContactFio, resolveContactPersonName} from "./functions/contactFio";
import {resolvePvzSearchLocation} from "./functions/pvzAddress";
import InfoSection from "./infoSection";
import CalcByPlaces from "./calcByPlaces";
import DocParams from "./docParams";
import TotalBlock from "./totalBlock";
import {calcWeight, changeValues, calcVolumesSum, calcWeightSum, cargoPackagesCount} from "./math";
import TotalVolumeAndWeight from "./totalVolumeAndWeight";
import {findPhoneNumbersInText} from 'libphonenumber-js';
import moment from 'moment';
import ResultData from "./resultData";
import {
    customMatchingServices,
    formServicesArray,
    returnOfAccompanyingDocumentsName,
    returnParcelName,
    DOCUMENT_MAX_WEIGHT,
    PRR_MAX_WEIGHT_DEFAULT,
    MATRIX_SERVICE_CODES,
    PRR_SERVICE_CODES,
    loadingUnloadingServiceName,
    lathingServiceName,
    servicesSignature,
    onlyMatrixServicesChanged,
    tariffSupportsSelectedServices
} from "./utils";
import ExtraServicesPanel from "./extraServicesPanel";
import Loader from "../../../components/Loader/Loader";
import {containsAnyLetter, onBeforeUnloadOff, onBeforeUnloadOn} from "../../../services/utils";
import SetCompanyBlock from "./setCompanyBlock";
import PayerTab from "./tabs/payerTab";
import LineLoader from "../../../components/Loader/LineLoader";
import {Prompt} from "react-router";
import BannerCalc from "./bannerCalc";
import PalletsForm from "./palletsForm";
import {getCarrierUiExtension} from "./carrierExtensions";

const ADDRESS_COMMENT_CARRIER_LIMIT_MESSAGE = 'Превышен лимит на количество символов в поле комментария для данной ТК.';

const ParamsStep = ({
                        total,
                        isDoc = false,
                        isPallets = false,
                        changeParam,
                        form,
                        onClick,
                        errors,
                        calcByPlacesOn,
                        setCalcByPlacesOn,
                        companyData,
                        initData
                    }) => {
    const cargoDescriptionField = <FormField error={errors['cargoDescription']}>
        <label>
            Описание содержимого*
            <Info
                name={'Описание содержимого'}
                text={
                    <div>
                        Полный перечень запрещенных к перевозке предметов указан <a target='_blank'
                                                                                    href={(companyData && companyData.publicOfferUrl) || ''}>в
                        публичной оферте</a>, а также будет указан на сайте ТК после ее выбора
                    </div>
                }/>
        </label>
        <Input
            maxLength={255}
            name='cargoDescription'
            value={form.cargoDescription || ''}
            onChange={(e, {name, value}) => changeParam(name, value)} placeholder={'НАПРИМЕР, ЦЕННЫЙ ГРУЗ'}
        />
    </FormField>

    const changeParamPallet = (name, value) => {
        if (name === 'palletsCount') {
            if (!form.isChangedPalletsData) {
                changeParam('palletsVolume', value * initData.palletsVolume);
                changeParam('palletsWeight', value * initData.palletsWeight);
            }
        } else {
            changeParam('isChangedPalletsData', true);
        }
        changeParam(name, value);
    }

    return <ParcelParamsBlock
        footerContent={total}
        onClick={onClick}
    >
        <Form>
            {(!isDoc && !isPallets) && <Fragment>
                <TotalVolumeAndWeight
                    form={form}
                    changeParam={changeParam}
                    errors={errors}
                    isOff={calcByPlacesOn}
                    onCalcByPlaces={(d) => {
                        setCalcByPlacesOn(d);
                        changeParam('positions', !d ? null : [{cargoPackages: 1}]);
                    }}
                />
                {calcByPlacesOn && <CalcByPlaces
                    isCreate
                    positions={form.positions || [{cargoPackages: 1}]}
                    changeParam={changeParam}
                    errors={errors}
                />}
            </Fragment>}

            {isPallets && <Fragment>
                <PalletsForm
                    form={form}
                    changeParam={changeParamPallet}
                    errors={errors}
                />
            </Fragment>}

            {isDoc && <DocParams
                form={form}
                changeParam={changeParam}
                errors={errors}
                field={cargoDescriptionField}
            />}

            {!isDoc && cargoDescriptionField}
        </Form>
    </ParcelParamsBlock>;
}

const addressName = (address) => {
    return !address ? '' : `${address.city ? `${address.city}` : ''}`;
}

const isDostavistaTariff = (tariff) => {
    if (!tariff) {
        return false;
    }

    const values = [
        tariff.carrierCode,
        tariff.carrierName,
        tariff.carrierServiceName,
        tariff.displayData && tariff.displayData.carrierCode,
        tariff.displayData && tariff.displayData.carrierName,
        tariff.displayData && tariff.displayData.carrierServiceName
    ];

    for (let i = 0; i < values.length; i++) {
        const val = values[i];
        if (!val) {
            continue;
        }

        const normalized = String(val).toLowerCase();
        if (normalized.includes('dostavista') || normalized.includes('достависта')) {
            return true;
        }
    }

    return false;
}

const ResultStepSettingsBlock = ({label, children, beta}) => {
    return (
        <div className='setting'>
            <h3>
                {label}
                {beta ? <span className='beta-badge'>бета</span> : null}
            </h3>
            {children}
        </div>
    );
}

const compareDates = (date1, date2) => {
    const date1format = "" + date1.getDate() + date1.getMonth() + date1.getFullYear();
    const date2format = "" + date2.getDate() + date2.getMonth() + date2.getFullYear();
    return date1format === date2format;
}

const filterSortOptions = [
    {
        key: 'cost',
        value: 'cost',
        text: 'Тариф'
    },
    {
        key: 'deliveryTime',
        value: 'deliveryTime',
        text: 'Ожидаемая дата доставки'
    },
    {
        key: 'carrierName',
        value: 'carrierName',
        text: 'Перевозчик'
    },
    {
        key: 'departureDate',
        value: 'departureDate',
        text: 'Плановая дата отгрузки'
    },
    {
        key: 'maxDays',
        value: 'maxDays',
        text: 'В пути'
    },
]

const ResultFilter = ({form, changeParam, sortBy, setSortBy, isCalc, weekdays}) => {

    return <Form className='result-filter'>
        <Form.Field>
            <label>
                Плановая дата отгрузки
            </label>
            <DatePicker
                excludeDates={weekdays.map(w => new Date(w))}
                minDate={startOfToday()}
                name='departureDate'
                className={compareDates(form.departureDate, new Date()) ? 'bold-input' : ''}
                dateFormat='dd.MM.yyyy'
                placeholderText='дд.мм.гггг'
                value={form.departureDate}
                valueText={compareDates(form.departureDate, new Date()) ? 'Сегодня' : null}
                onChange={(e, {value}) => changeParam('departureDate', value)}
            />
        </Form.Field>

        <Form.Field>
            <label>
                Сортировать по:
            </label>
            <Dropdown
                name='sortBy'
                value={sortBy}
                onChange={(e, {name, value}) => setSortBy(value)}
                options={filterSortOptions.filter(o => !isCalc || o.key !== 'carrierName')}
            />
        </Form.Field>
    </Form>
}

const allTariffServicesCodes = (tariffs) => {
    let codes = [];
    tariffs.forEach(t => (t.services || []).forEach(s => {
        !codes.includes(s.code) && codes.push(s.code);
    }));
    return codes;
}

const buildSidebarServices = (services, tariffs, isCargo, showExtraServices) => {
    const tariffCodes = allTariffServicesCodes(tariffs);
    const availableServices = services.filter(service => tariffCodes.includes(service.value));
    const returnServices = availableServices.filter(s => s.value === returnParcelName || s.value === returnOfAccompanyingDocumentsName);
    const matrixServices = showExtraServices && isCargo
        ? services.filter(s => MATRIX_SERVICE_CODES.includes(s.value))
        : [];
    const otherServices = availableServices.filter(s =>
        s.value !== returnParcelName
        && s.value !== returnOfAccompanyingDocumentsName
        && !MATRIX_SERVICE_CODES.includes(s.value)
    );
    const loadingUnloadingService = isCargo ? services.find(s => s.value === loadingUnloadingServiceName) : null;
    if (loadingUnloadingService && !otherServices.some(s => s.value === loadingUnloadingServiceName)) {
        otherServices.unshift(loadingUnloadingService);
    }
    return {returnServices, matrixServices, otherServices};
}

const ResultStep = ({
                        total,
                        tariffs = [],
                        loading,
                        deliveryTypes = [],
                        services = [],
                        form,
                        changeParam,
                        setStep,
                        onClick,
                        isCalc = false,
                        isCalcV2 = false,
                        isTanderCalc = false,
                        weekdays,
                        saveDraftBtn,
                        hasPvzCdekCarrier = false,
                        parcelTypes,
                        showExtraServices = false,
                        setCalcByPlacesOn
                    }) => {

    const [sortBy, setSortBy] = useState(filterSortOptions[0].value);
    const deliveryTypeRef = useRef(form.deliveryType);

    const changeFilter = (name, value) => {
        changeParam(name, value);
    }

    useEffect(() => {
        form.departureDate && onClick();
    }, [form.departureDate]);

    useEffect(() => {
        if (deliveryTypeRef.current !== form.deliveryType && form.deliveryType != null) {
            onClick();
        }
        deliveryTypeRef.current = form.deliveryType;
    }, [form.deliveryType]);

    const filterByServices = (tariffs = []) => {
        return tariffs.filter(tariff => tariffSupportsSelectedServices(tariff, form));
    }

    const sortTariffs = (tariffs) => {

        return filterByServices(tariffs).sort(function (a, b) {
            if (sortBy === 'deliveryTime') {
                if ((!a['minDeliveryTime'] && !a['minDeliveryTime']) && !(!b['minDeliveryTime'] && !b['minDeliveryTime'])) return 1;
                if (!(!a['minDeliveryTime'] && !a['minDeliveryTime']) && (!b['minDeliveryTime'] && !b['minDeliveryTime'])) return -1;
                if (parseDate(a['minDeliveryTime']) > parseDate(b['minDeliveryTime'])) return 1;
                if (parseDate(a['minDeliveryTime']) < parseDate(b['minDeliveryTime'])) return -1;
                if (parseDate(a['maxDeliveryTime']) > parseDate(b['maxDeliveryTime'])) return 1;
                if (parseDate(a['maxDeliveryTime']) < parseDate(b['maxDeliveryTime'])) return -1;
            } else {
                if (a.displayData[sortBy] > b.displayData[sortBy]) {
                    return 1;
                }
                if (a.displayData[sortBy] < b.displayData[sortBy]) {
                    return -1;
                }
            }
            return 0;
        })
    }

    const hasPlaceDimensions = (form.positions || []).length > 0
        && (form.positions || []).every(p => p.length && p.width && p.height);
    const shipmentWeight = form.parcelType === parcelTypes.parcelTypeDoc
        ? Number(form.documentWeight || 0)
        : Number(form.cargoWeight || form.palletsWeight || 0);
    const isMatrixServiceDisabled = (service) =>
        (PRR_SERVICE_CODES.includes(service.value) && shipmentWeight <= PRR_MAX_WEIGHT_DEFAULT)
        || (service.value === lathingServiceName && !hasPlaceDimensions);
    const matrixServiceTooltip = (service) => {
        if (PRR_SERVICE_CODES.includes(service.value) && shipmentWeight <= PRR_MAX_WEIGHT_DEFAULT) {
            return 'Услуга включена в базовый тариф для отправлений весом до 30 кг включительно.';
        }
        if (service.value === lathingServiceName && !hasPlaceDimensions) {
            return 'Для расчета/заказа услуги "Обрешетка" необходимо указать размеры каждого из мест отправления.';
        }
        return null;
    };

    const setServices = (name, value) => {
        const s = form.services || {};
        const newServices = {
            ...s,
            [name]: value
        };
        if (name === returnOfAccompanyingDocumentsName && newServices[returnParcelName]) {
            newServices[returnParcelName] = false;
        }
        if (name === returnParcelName && newServices[returnOfAccompanyingDocumentsName]) {
            newServices[returnOfAccompanyingDocumentsName] = false;
        }
        changeParam('services', newServices);
    }

    const availableServices = services.filter(service => allTariffServicesCodes(tariffs).includes(service.value))
    const isCargo = !parcelTypes || form.parcelType === parcelTypes.parcelTypeCargo || form.parcelType === parcelTypes.parcelTypePallets
    const {returnServices, matrixServices, otherServices} = buildSidebarServices(services, tariffs, isCargo, showExtraServices)
    const pvzDeliveryTypeCodes = ['4', '5', '6'];
    const filteredDeliveryTypes = (deliveryTypes || []).filter(dT => {
        const code = dT && dT.value != null ? String(dT.value) : '';
        if (pvzDeliveryTypeCodes.includes(code)) {
            return hasPvzCdekCarrier;
        }
        return true;
    });

    return (
        <DataBlock
            label={loading ? 'Идет загрузка предложений...' : 'Результаты поиска'}
            maxSize
        >
            <LineLoader active={loading}/>
            <Section
                footerContent={total}
            />
            <div className='result-step'>
                <div className='result-step__table'>
                    <ResultFilter
                        weekdays={weekdays}
                        form={form}
                        changeParam={changeFilter}
                        setSortBy={setSortBy}
                        sortBy={sortBy}
                        isCalc={isCalc}
                    />
                    <ResultData
                        loading={loading && (!tariffs || tariffs.length < 1)}
                        tariffs={sortTariffs(tariffs)}
                        form={form}
                        setStep={setStep}
                        changeParam={changeParam}
                        isCalc={isCalc}
                        isCalcV2={isCalcV2}
                        isTanderCalc={isTanderCalc}
                    />
                </div>

                <div className='result-step__settings'>
                    <CardBlock>
                        <ResultStepSettingsBlock label={'Условия доставки'}>
                            {
                                filteredDeliveryTypes
                                    .map(dT => (
                                        <Form.Field key={dT.label} className='result-step__item'
                                                    disabled={!dT.hasIntegration}>
                                            {dT.hasIntegration && <Radio
                                                checked={form.deliveryType === dT.value}
                                                label={dT.label}
                                                onChange={() => {
                                                    changeParam('deliveryType', dT.value)
                                                }}
                                            />}
                                        </Form.Field>
                                    ))
                            }
                        </ResultStepSettingsBlock>

                        {returnServices.length ? <ResultStepSettingsBlock label={'Возвраты'}>
                            <ExtraServicesPanel
                                services={returnServices}
                                form={form}
                                setServices={setServices}
                            />
                        </ResultStepSettingsBlock> : null}

                        {otherServices.length ? <ResultStepSettingsBlock label={'Доп. услуги'}>
                            <ExtraServicesPanel
                                services={otherServices}
                                form={form}
                                setServices={setServices}
                            />
                        </ResultStepSettingsBlock> : null}

                        {matrixServices.length ? <ResultStepSettingsBlock label={'Погрузка / разгрузка / обрешётка'} beta>
                            <ExtraServicesPanel
                                services={matrixServices}
                                form={form}
                                setServices={setServices}
                                isItemDisabled={isMatrixServiceDisabled}
                                itemTooltipText={matrixServiceTooltip}
                            />
                        </ResultStepSettingsBlock> : null}
                    </CardBlock>
                    {saveDraftBtn && saveDraftBtn}
                    {
                        isCalc && <Button
                            className='modal__btn-cancel m-t-16 btn_light-blue btn__pooling'
                            onClick={() => {
                                if (isTanderCalc) {
                                    window.open('https://auth.artlogic-sk.ru/Identity/Account/ExpressLogin#register', "_self");
                                } else {
                                    window.open(`https://pooling.me/${isCalcV2 ? 'contactuscalc' : 'contactwithus'}`);
                                }
                            }}
                        >
                            <b>Подключиться к Pooling</b>
                        </Button>
                    }
                    {
                        isCalc && <BannerCalc/>
                    }
                </div>
            </div>
        </DataBlock>
    )
}

const CreateStep = (
    {
        form = {},
        changeForm: onChangeForm,
        changeParams,
        companyId,
        resetData,
        total,
        companyData,
        deliveryTypes,
        setStep,
        onChangeAddress,
        createParcel,
        errors,
        loading,
        loadingTariffs,
        services,
        parcelTypes,
        weekdays,
        saveDraftBtn,
        setErrors,
        payerValidateRef,
        valueDeclaredDisabled,
        insuranceCostIsNull,
        showExtraServices = false
    }) => {

    const [dateChanged, setDateChanged] = useState(false);
    const [payerTabVisible, setPayerTabVisible] = useState(false);

    const changeForm = (name, value) => {
        if (name === 'isValueDeclared' && insuranceCostIsNull && !!value) {
            toast.info("Стоимость страхования будет рассчитана перевозчиком после создания отправления");
        }
        name === 'departureDate' && setDateChanged(true);
        onChangeForm(name, value);
    }

    const isDoc = form.parcelType === parcelTypes.parcelTypeDoc;
    const isCargo = form.parcelType === parcelTypes.parcelTypeCargo || form.parcelType === parcelTypes.parcelTypePallets;
    const checkoutCatalogServices = services || [];
    const checkoutReturnServices = checkoutCatalogServices.filter(s => s.value === returnParcelName || s.value === returnOfAccompanyingDocumentsName);
    const checkoutMatrixServices = showExtraServices && isCargo
        ? checkoutCatalogServices.filter(s => MATRIX_SERVICE_CODES.includes(s.value))
        : [];
    const checkoutTariffCodes = allTariffServicesCodes(form.selectedTariff ? [form.selectedTariff] : []);
    const checkoutOtherServices = checkoutCatalogServices.filter(s =>
        s.value !== returnParcelName
        && s.value !== returnOfAccompanyingDocumentsName
        && !MATRIX_SERVICE_CODES.includes(s.value)
        && (s.value === loadingUnloadingServiceName || checkoutTariffCodes.includes(s.value))
    );
    const setCheckoutServices = (name, value) => {
        const s = form.services || {};
        const newServices = {
            ...s,
            [name]: value
        };
        if (name === returnOfAccompanyingDocumentsName && newServices[returnParcelName]) {
            newServices[returnParcelName] = false;
        }
        if (name === returnParcelName && newServices[returnOfAccompanyingDocumentsName]) {
            newServices[returnOfAccompanyingDocumentsName] = false;
        }
        changeForm('services', newServices);
    };
    const payerRef = useRef();

    useEffect(() => {
        if (!payerRef.current || !payerRef.current.reloadReferences || !companyId) {
            return;
        }
        payerRef.current.reloadReferences().then(a => {
            const visible = a[2] || false;
            setPayerTabVisible(visible);
            changeForm('payerTabVisible', visible);
        });
    }, [companyId]);

    const payerTabChange = (newFieldValues) => {
        return new Promise((resolve) => {
            let parcel = form;
            newFieldValues.map((field) => {
                parcel[field.name] = field.value;
            });
            changeParams(parcel);
            resolve();
        });
    }

    useEffect(() => {
        if (!payerTabVisible) {
            return;
        }
        setPayerErrors();
    }, [form, payerTabVisible]);

    useEffect(() => {
        if (payerValidateRef) {
            payerValidateRef.current = () => (payerRef.current ? payerRef.current.validateForm() : null);
        }
    });

    const setPayerErrors = () => {
        if (!payerRef.current || !payerTabVisible) {
            return;
        }
        const payerErrs = payerRef.current.validateForm();
        if (!payerErrs) {
            return;
        }
        setErrors((prev) => ({
            ...(prev || {}),
            ...payerErrs
        }));
    }

    const setFieldError = (field, message) => {
        setErrors((prev) => ({
            ...(prev || {}),
            [field]: message || null
        }));
    };

    const mergePayerValidationErrors = (payerErrs) => {
        if (!payerErrs) {
            return;
        }
        setErrors((prev) => ({
            ...(prev || {}),
            ...payerErrs
        }));
    };

    return (
        <DataBlock
            label={'Создать отправление'}
            maxSize
        >
            <div className='result-step'>
                <div className='result-step__table'>
                    <PointAddress
                        isFrom
                        form={form}
                        changeForm={changeForm}
                        companyId={companyId}
                        changeParams={changeParams}
                        onChangeAddress={onChangeAddress}
                        errors={errors}
                        isCreate
                        setFieldError={setFieldError}
                    />

                    <PointAddress
                        form={form}
                        changeForm={changeForm}
                        companyId={companyId}
                        changeParams={changeParams}
                        onChangeAddress={onChangeAddress}
                        errors={errors}
                        isCreate
                        setFieldError={setFieldError}
                    />

                    <span style={{display: !payerTabVisible ? 'none' : 'block'}}>
                        <PayerTab
                            ref={payerRef}
                            parcel={form}
                            errors={errors}
                            isNew
                            isBusy={loading}
                            onFieldChange={payerTabChange}
                            onValidationChange={mergePayerValidationErrors}
                        />
                    </span>

                    <InfoSection
                        weekdays={weekdays}
                        temperatureRegime={formServicesArray(form).includes('temperatureRegime')}
                        resetData={resetData}
                        total={total}
                        form={form}
                        changeForm={changeForm}
                        companyData={companyData}
                        errors={errors}
                        isDoc={isDoc}
                        isCreate
                        valueDeclaredDisabled={valueDeclaredDisabled}
                    />

                    <div className='step-btn-block m-t-16'>
                        <div className='required-fields-note required-fields-note_large'>
                            * поля обязательные для заполнения
                        </div>
                    </div>
                    <div className='step-btn-block m-t-25'>
                        <Button
                            disabled={loading || (loadingTariffs && dateChanged) || form.saveDisabled}
                            className='step-btn-block__btn step-btn-block__btn_final' color={'blue'}
                            onClick={() => createParcel()}
                            id='opacity1'
                        >
                            {
                                loading || (loadingTariffs && dateChanged) ?
                                    <div className='step-btn-block__loader'>
                                        <div>{loading ? 'Загрузка данных в систему' : 'Обновление тарифа'}</div>
                                        <Segment vertical>
                                            <Load inverted active size='tiny'/>
                                        </Segment>
                                    </div>
                                    : 'Заказать отправление'
                            }
                        </Button>
                    </div>
                    <div className='step-btn-block m-t-16'>
                        <div className='personal-data'>
                            Нажимая кнопку «Заказать отправление», я соглашаюсь <a target='_blank'
                                href={companyData.publicOfferUrl || ''}>с
                                условиями публичной оферты, работы
                                курьерских служб</a> и даю согласие на обработку персональных данных.
                        </div>
                    </div>
                    <div className='step-btn-block m-t-7'>
                        <div className='personal-data'>
                            <a href='/'>Отменить</a>
                        </div>
                    </div>
                </div>

                <div className='result-step__settings'>
                    <CostCalcBlock form={form} deliveryTypes={deliveryTypes} services={services}
                                   parcelTypes={parcelTypes}/>
                    <Info
                        trigger={<Button className='modal__btn-cancel' onClick={() => {
                            setStep(3);
                        }}>
                            Выбрать другой тариф
                        </Button>}
                        text={'Введенные Вами данные будут сохранены при выборе другой транспортной компании'}
                    />
                    {saveDraftBtn && saveDraftBtn}
                    {(checkoutReturnServices.length || checkoutOtherServices.length || checkoutMatrixServices.length) ? (
                        <Info
                            trigger={
                                <div className='checkout-services checkout-services_disabled'>
                                    {checkoutReturnServices.length ? <CardBlock>
                                        <ResultStepSettingsBlock label={'Возвраты'}>
                                            <ExtraServicesPanel
                                                services={checkoutReturnServices}
                                                form={form}
                                                setServices={setCheckoutServices}
                                                disabled
                                            />
                                        </ResultStepSettingsBlock>
                                    </CardBlock> : null}
                                    {checkoutOtherServices.length ? <CardBlock>
                                        <ResultStepSettingsBlock label={'Доп. услуги'}>
                                            <ExtraServicesPanel
                                                services={checkoutOtherServices}
                                                form={form}
                                                setServices={setCheckoutServices}
                                                disabled
                                            />
                                        </ResultStepSettingsBlock>
                                    </CardBlock> : null}
                                    {checkoutMatrixServices.length ? <CardBlock>
                                        <ResultStepSettingsBlock label={'Погрузка / разгрузка / обрешётка'} beta>
                                            <ExtraServicesPanel
                                                services={checkoutMatrixServices}
                                                form={form}
                                                setServices={setCheckoutServices}
                                                disabled
                                            />
                                        </ResultStepSettingsBlock>
                                    </CardBlock> : null}
                                </div>
                            }
                            text={'Добавление/удаление услуг осуществляется до выбора тарифа. Нажмите "Выбрать другой тариф" для добавления/удаления услуг и повторного расчета.'}
                        />
                    ) : null}
                </div>
            </div>
        </DataBlock>
    )
}

const CostCalcBlock = ({form, deliveryTypes, services = [], parcelTypes}) => {
    if (!form || !form.selectedTariff) {
        return null;
    }

    const carrierExtension = getCarrierUiExtension(form.selectedTariff);
    const shortTariffTitle = carrierExtension.getShortTariffTitle(form.selectedTariff);

    const isDoc = form.parcelType === parcelTypes.parcelTypeDoc;
    const isPallets = form.parcelType === parcelTypes.parcelTypePallets;

    return <div className='cost-calc'>
        <div className='cost-calc__background'>
            <div className='cost-calc__label'>
                Предварительный расчет
            </div>
            <div className='cost-calc__points'>
                <div className='cost-calc__params'>
                    <div className='cost-calc__carrier'>
                        <Logos
                            name={(form.selectedTariff || {}).carrierCode}
                            carrierTitle={(form.selectedTariff || {}).carrierName}
                        />
                        <div className='carrier-tariff-block'>
                            <div className='carrier-tariff-inline'>
                                <div className='carrier-tariff-inline__title'>{shortTariffTitle}</div>
                                <Info
                                    className='carrier-tariff-inline__icon'
                                    name={(form.selectedTariff || {}).carrierName}
                                    label={(form.selectedTariff || {}).carrierServiceName}
                                    text={(form.selectedTariff || {}).carrierServiceDescription}
                                    position={'right'}
                                    offset={[7]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#99D402"/>
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white"/>
                    </svg>
                    <div>
                        {addressName(form.shipmentAddress)}
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#459EFF"/>
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white"/>
                    </svg>
                    <div>
                        {addressName(form.deliveryAddress)}
                    </div>
                </div>
                <div className='cost-calc__params'>
                    {!isDoc ? 'Груз' : 'Документы'}, {((deliveryTypes || []).find(dt => dt.value === form.deliveryType) || {}).label}
                </div>
                <div className='cost-calc__params'>
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Кол-во мест:
                        </div>
                        <div className='cost-calc__value'>
                            {(form || {}).cargoPackages || 0}
                        </div>
                    </div>}
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Общий объем:
                        </div>
                        <div className='cost-calc__value'>
                            {(form || {}).cargoVolume || 0} м³
                        </div>
                    </div>}
                    <div className='cost-calc__param'>
                        <div>
                            Общий вес:
                        </div>
                        <div className='cost-calc__value'>
                            {isDoc ? ((form || {}).documentWeight || 0) : (form || {}).cargoWeight || 0} кг
                        </div>
                    </div>
                    {!isDoc && !isPallets && <div className='cost-calc__param'>
                        <div>
                            Объемный вес:
                        </div>
                        <div className='cost-calc__value'>
                            {calcWeight(form)} кг
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__params'>
                    <div className='cost-calc__param'>
                        <div>
                            Тариф
                        </div>
                        <div className='cost-calc__value'>
                            {((form.selectedTariff && form.selectedTariff.cost) || 0).toFixed(2)} ₽
                        </div>
                    </div>
                    {
                        formServicesArray(form).map(s => {
                            const extraCost = serviceTariff(s, form).cost;
                            if (extraCost == null || extraCost === '') {
                                return null;
                            }
                            const service = services.find(sf => sf.value === s) || {};
                            return (<div className='cost-calc__param' key={s}>
                                <div>
                                    {service.name || s}
                                </div>
                                <div className='cost-calc__value cost-calc__value_green'>
                                    +{extraCost || 0} ₽
                                </div>
                            </div>)
                        })
                    }
                    {form.selectedTariff && form.selectedTariff.serviceFee && <div className='cost-calc__param'>
                        <div>
                            Сервисный сбор
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{form.selectedTariff.serviceFee} ₽
                        </div>
                    </div>
                    }
                    {form.isValueDeclared && <div className='cost-calc__param'>
                        <div>
                            Страхование
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{form.insuranceCost || 0} ₽
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__total'>
                    {costFormat(calcSum(form))} ₽
                </div>
            </div>
        </div>
    </div>
}

/** Убирает повтор строк с тем же перевозчиком, кодом услуги и датой забора (гонки повторных loadTariffs). */
/** Ключ даты отправления (yyyy-MM-dd) — у КСЭ/PE один carrierServiceCode на «сегодня» и «завтра». */
const getTariffDepartureKey = (tariff) => {
    if (!tariff || !tariff.departureDate) return '';
    try {
        return formatDateISO(tariff.departureDate) || '';
    } catch (e) {
        return String(tariff.departureDate).slice(0, 10);
    }
};

/** Совпадение тарифа без даты: код услуги + ТК + тип ТС. */
const isSameTariffIdentity = (a, b) => {
    if (!a || !b) return false;
    if (String(a.carrierId) !== String(b.carrierId)) return false;
    if (String(a.carrierServiceCode || '') !== String(b.carrierServiceCode || '')) return false;
    return String(a.vehicleTypeId || '') === String(b.vehicleTypeId || '');
};

/** Совпадение тарифа: код услуги + ТК + тип ТС + дата забора. */
const isSameTariff = (a, b) => {
    if (!isSameTariffIdentity(a, b)) return false;
    const dateA = a.departureDate;
    const dateB = b.departureDate;
    if (dateA && dateB) {
        try {
            return isSameDay(dateA, dateB);
        } catch (e) {
            return getTariffDepartureKey(a) === getTariffDepartureKey(b);
        }
    }
    // Если у одной стороны даты нет — не считаем совпадением при наличии другой даты
    // (иначе «сегодня» и «завтра» снова схлопнутся).
    if (dateA || dateB) return false;
    return true;
};

/** Ищет актуальный оффер после смены даты забора. */
const findTariffAfterDepartureChange = (tariffsList, selectedTariff, departureDate) => {
    if (!tariffsList || !tariffsList.length || !selectedTariff) {
        return null;
    }
    const exact = tariffsList.find(trf => isSameTariff(trf, selectedTariff));
    if (exact) {
        return exact;
    }
    const sameIdentity = tariffsList.filter(trf => isSameTariffIdentity(trf, selectedTariff));
    if (!sameIdentity.length) {
        return null;
    }
    if (departureDate) {
        const byDate = sameIdentity.find(trf =>
            !trf.departureDate || isSameDay(trf.departureDate, departureDate)
        );
        if (byDate) {
            return byDate;
        }
    }
    return sameIdentity.length === 1 ? sameIdentity[0] : null;
};

/** Подменяет/добавляет выбранный тариф в списке для сохранения. */
const mergeSelectedTariffIntoList = (tariffsList, previousSelected, nextSelected) => {
    const list = tariffsList ? [...tariffsList] : [];
    if (!nextSelected) {
        return list;
    }
    const exactIdx = list.findIndex(t => isSameTariff(t, nextSelected));
    if (exactIdx >= 0) {
        list[exactIdx] = nextSelected;
        return list;
    }
    const prevIdx = previousSelected
        ? list.findIndex(t => isSameTariff(t, previousSelected) || isSameTariffIdentity(t, previousSelected))
        : -1;
    if (prevIdx >= 0) {
        list[prevIdx] = nextSelected;
        return list;
    }
    const identityIdx = list.findIndex(t => isSameTariffIdentity(t, nextSelected));
    if (identityIdx >= 0) {
        list[identityIdx] = nextSelected;
        return list;
    }
    list.push(nextSelected);
    return list;
};

/** Строит carrierCostRequests с ровно одним IsSelected для выбранного тарифа. */
const buildCarrierCostRequests = (tariffsList, selectedTariff) => {
    if (!tariffsList) {
        return null;
    }
    const list = mergeSelectedTariffIntoList(tariffsList, selectedTariff, selectedTariff);
    const requests = list.map(t => ({
        carrierId: t.carrierId,
        carrierServiceCode: t.carrierServiceCode,
        carrierServiceName: t.carrierServiceName,
        cost: t.cost,
        rawCost: t.rawCost,
        tariffRate: t.tariffRate,
        departureDate: t.departureDate,
        minDeliveryTime: t.minDeliveryTime,
        maxDeliveryTime: t.maxDeliveryTime,
        deliveryTimeComment: t.deliveryTimeComment,
        status: t.status,
        statusComment: t.statusComment,
        isSelected: isSameTariff(selectedTariff, t),
        claimId: t.claimId,
        version: t.version,
        tariff: t.tariff,
        services: t.services
    }));

    if (!selectedTariff || requests.some(r => r.isSelected)) {
        return requests;
    }

    // После смены даты isSameTariff может не совпасть — выбираем по identity (+ дате выбранного).
    let keepIdx = list.findIndex(t =>
        isSameTariffIdentity(t, selectedTariff)
        && (!selectedTariff.departureDate || !t.departureDate || isSameDay(t.departureDate, selectedTariff.departureDate))
    );
    if (keepIdx < 0) {
        keepIdx = list.findIndex(t => isSameTariffIdentity(t, selectedTariff));
    }
    if (keepIdx < 0 && list.length) {
        keepIdx = list.length - 1;
    }
    if (keepIdx < 0) {
        return requests;
    }
    return requests.map((r, i) => ({
        ...r,
        isSelected: i === keepIdx
    }));
};

const dedupeTariffCosts = (arr, isCalc) => {
    if (!arr || !arr.length) return arr;
    const seen = new Set();
    const out = [];
    for (const t of arr) {
        const id = isCalc ? (t.carrierCode || '') : t.carrierId != null ? String(t.carrierId) : '';
        const code = isCalc ? (t.carrierServiceName || '') : t.carrierServiceCode != null ? String(t.carrierServiceCode) : '';
        // Для некоторых перевозчиков (например Dostavista) один и тот же код услуги
        // может отличаться по VehicleTypeId. Без этого схлопываются разные тарифы.
        const vehicleTypeId = t.vehicleTypeId != null ? String(t.vehicleTypeId) : '';
        // КСЭ/PE: один код услуги на разные даты забора — иначе «сегодня» и «завтра» схлопываются,
        // а при сохранении isSelected ошибочно помечает обе строки.
        const departureKey = getTariffDepartureKey(t);
        const k = `${id}|${code}|${vehicleTypeId}|${departureKey}`;
        if (seen.has(k)) continue;
        seen.add(k);
        out.push(t);
    }
    return out;
};

const Step = ({
                  step,
                  form,
                  changeForm,
                  changeParams,
                  onClick,
                  tariffs,
                  loading,
                  loadingCreate,
                  deliveryTypes,
                  setStep,
                  companyId,
                  resetData,
                  companyData,
                  onChangeAddress,
                  createParcel,
                  services,
                  errors,
                  parcelTypes,
                  isCalc = false,
                  isCalcV2 = false,
                  isTanderCalc = false,
                  calcByPlacesOn,
                  setCalcByPlacesOn,
                  weekdays,
                  saveDraftBtn,
                  setErrors,
                  payerValidateRef,
                  initData,
                  getValueDeclaredDisabled,
                  insuranceCostIsNull,
                  hasPvzCdekCarrier = false,
                  showExtraServices = false
              }) => {
    const valueDeclaredDisabled = useMemo(() => getValueDeclaredDisabled(form, parcelTypes), [form, parcelTypes]);

    switch (step) {
        case parcelTypes.parcelTypeCargo:
            return <ParamsStep
                companyData={companyData}
                calcByPlacesOn={calcByPlacesOn}
                setCalcByPlacesOn={setCalcByPlacesOn}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock calcByPlacesOn={calcByPlacesOn} resetData={resetData} form={form}/>}
                onClick={() => onClick(true)}
                errors={errors}
            />;
        case parcelTypes.parcelTypeDoc:
            return <ParamsStep
                companyData={companyData}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock resetData={resetData} form={form} isDoc/>}
                onClick={() => onClick(true)}
                errors={errors}
                isDoc
            />;
        case parcelTypes.parcelTypePallets:
            return <ParamsStep
                companyData={companyData}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock resetData={resetData} form={form} isPallets/>}
                onClick={() => onClick(true)}
                errors={errors}
                isPallets
                initData={initData}
            />;
        case 3:
            return <ResultStep
                weekdays={weekdays}
                deliveryTypes={deliveryTypes}
                services={services}
                form={form}
                changeParam={changeForm}
                onClick={onClick}
                parcelTypes={parcelTypes}
                hasPvzCdekCarrier={hasPvzCdekCarrier}
                total={<TotalBlock
                    resetData={resetData}
                    form={form}
                    isPallets={form.parcelType === parcelTypes.parcelTypePallets}
                    isDoc={form.parcelType === parcelTypes.parcelTypeDoc}
                    isResult
                />}
                tariffs={tariffs}
                loading={loading}
                setStep={setStep}
                errors={errors}
                isCalc={isCalc}
                isCalcV2={isCalcV2}
                isTanderCalc={isTanderCalc}
                saveDraftBtn={saveDraftBtn}
                showExtraServices={showExtraServices}
                setCalcByPlacesOn={setCalcByPlacesOn}
            />;
        case 4:
            return <CreateStep
                weekdays={weekdays}
                form={form}
                changeForm={changeForm}
                changeParams={changeParams}
                companyId={companyId}
                resetData={resetData}
                total={<TotalBlock resetData={resetData} form={form}
                                   isDoc={form.parcelType === parcelTypes.parcelTypeDoc}/>}
                companyData={companyData}
                deliveryTypes={deliveryTypes}
                setStep={setStep}
                onChangeAddress={onChangeAddress}
                createParcel={createParcel}
                errors={errors}
                loading={loadingCreate}
                loadingTariffs={loading}
                services={services}
                parcelTypes={parcelTypes}
                saveDraftBtn={saveDraftBtn}
                setErrors={setErrors}
                payerValidateRef={payerValidateRef}
                valueDeclaredDisabled={valueDeclaredDisabled}
                insuranceCostIsNull={insuranceCostIsNull}
                showExtraServices={showExtraServices}
            />;
        default:
            return null;
    }
}

const serviceTariff = (s, form) => {
    const services = (form && form.selectedTariff && form.selectedTariff.services) || [];
    return services.find(sT => sT.code === s) || {};
}

const calcSum = (form) => {
    let sum = (form.selectedTariff && form.selectedTariff.cost) || 0;

    if (form.selectedTariff && form.selectedTariff.serviceFee) sum += form.selectedTariff.serviceFee;

    if (form.isValueDeclared) sum += (form.insuranceCost || 0);
    formServicesArray(form).forEach(s => {
        const extraCost = Number.parseFloat(serviceTariff(s, form).cost);
        if (!Number.isNaN(extraCost)) {
            sum += extraCost;
        }
    })
    return sum;
}

const CreateParcelForm = ({history, match, isCalc = false, isCalcV2 = false, isTanderCalc = false}) => {

    i18n.changeLanguage('ru');

    let copyId = match && match.params && match.params.copyId;
    let draftId = match && match.params && match.params.draftId;
    let subCompanyId = getCurrentUserSubCompanyId();
    let isCoordinator = (getRoles() || []).includes('Coordinator');
    const [companyId, setCompanyId] = useState(null);

    const [companyData, setCompanyData] = useState({});

    const loadCompanyData = () => {
        changeParamsForm({ companyId });

        apiGet('parcels/ref/companies/' + companyId)
            .then(data => {
                setCompanyData(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    useEffect(() => {
        let currentCompanyId = getCurrentUserCompanyId();
        setCompanyId(currentCompanyId);

        let allCompanyIds = getCurrentUserAllCompanyIds();
        (!isCalc && (!currentCompanyId || allCompanyIds.length > 1)) && setStep(-1);
    }, []);

    useEffect(() => {
        !isCalc && companyId && loadCompanyData();
    }, [companyId]);

    //step -1: Ввод ЮЛ
    //step 0: Ввод точек и типа груза
    //step 1: Параметры отправления - Документы
    //step 2: Параметры отправления - Груз
    //step 22: Параметры отправления - Паллеты
    //step 3: Результаты поиска
    //step 4: Создать отправление
    const [step, setStep] = useState(0);

    const [errors, setErrors] = useState(null);
    const [payerTabErrors, setPayerTabErrors] = useState(null);
    const payerValidateRef = useRef(null);

    const [tariffs, setTariffs] = useState(null);

    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [services, setServices] = useState([]);
    const [hasPvzCdekCarrier, setHasPvzCdekCarrier] = useState(false);

    const [confirmModal, setConfirmModal] = useState(false);

    const [loadingTariffs, setLoadingTariffs] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loadingDraftSave, setLoadingDraftSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const [syncTariffDeparture, setSyncTariffDeparture] = useState(false);

    const [parcelTypes, setParcelTypes] = useState({
        parcelTypeDoc: 1,
        parcelTypeCargo: 2,
        parcelTypePallets: 22
    });

    const [calcByPlacesOn, setCalcByPlacesOn] = useState(false);

    const loadTariffsGenerationRef = useRef(0);

    const initCountryCode = 'RU';

    const initForm = {
        sessionKey: uuidv4(),
        parcelType: null,

        shipmentCity: {
            // countryCode: initCountryCode
        },
        deliveryCity: {
            // countryCode: initCountryCode
        },

        shipmentAddress: {
            // countryCode: initCountryCode
        },

        deliveryAddress: {
            // countryCode: initCountryCode
        },

        // shipmentCountryCode: initCountryCode,

        // deliveryCountryCode: initCountryCode,

        departureDate: getCurrentOrNextBusinessDay(),
        palletsCount: 1,
        palletsVolume: 1.5,
        palletsWeight: 400,
        cargoWeight: 0.1,
        documentWeight: 0.2,
        cargoVolume: 0.0015,
        documentVolume: 0.0015,
        cargoPackages: 1,
        tariffs: null,
        selectedTariff: null,
        canEditFromAddress: true,
        canEditToAddress: true,
        positions: null,

        fromAddressCountry: null,
        fromAddressId: null,
        fromAddressName: null,
        originFromCityName: null,

        foAddressCountry: null,
        toAddressId: null,
        toAddressName: null,
        originToCityName: null,

        parcelId: null,
        vehicleTypeId: null,
        senderComment: '',
        senderCommentEnabled: false,
        carrierPublicOfferUrl: null,

        declaredCargoValue: 300,

        tempConditionHigh: null,
        tempConditionLow: null,

        isValueDeclared: true,

        companyId: getCurrentUserCompanyId(),

        shipmentContactLastName: null,
        shipmentContactFirstName: null,
        shipmentContactPatronymic: null,
        deliveryContactLastName: null,
        deliveryContactFirstName: null,
        deliveryContactPatronymic: null
    };

    const [form, setForm] = useState(initForm);
    const formRef = useRef(form);
    formRef.current = form;
    const companyDataRef = useRef(companyData);
    companyDataRef.current = companyData;
    const tariffsRef = useRef(tariffs);
    tariffsRef.current = tariffs;
    const servicesSig = useMemo(() => servicesSignature(form), [form.services]);

    const getLastCountries = () => {
        apiPost('parcels/addresses/lastCountries').then(d => {
            changeParamsForm({
                shipmentCountryCode: d.shipmentCodeCountry || initCountryCode,
                deliveryCountryCode: d.deliveryCodeCountry || initCountryCode,
            })
        }).catch(e => console.log(e));
    }

    useEffect(() => {
        if (form.parcelType
            && (form.shipmentAddress.postalCode || form.shipmentAddress.estimatedPostalCode || form.shipmentAddress.isIndexCanBeEmpty)
            && (form.deliveryAddress.postalCode || form.deliveryAddress.estimatedPostalCode || form.deliveryAddress.isIndexCanBeEmpty)) {
            setStep(form.parcelType);
        };
    }, [form.parcelType, form.shipmentCity.fullName, form.deliveryCity.fullName]);

    const calcInsuranceCost = throttle(() => {
        apiPost('parcels/insurance', {
            parcelType: form.parcelType,
            declaredCargoValue: form.declaredCargoValue,
            isNoDeclaredValueConfirmation: form.isNoDeclaredValueConfirmation
        })
            .then(response => {
                changeForm('insuranceCost', response.value);
                setErrors(errors => ({
                    ...errors,
                    declaredCargoValue: response.value === null ? 'Неверная сумма' : null
                }))
            });
    }, 300);

    const getValueDeclaredDisabled = (form, parcelTypes) => {
        return form.selectedTariff && (form.parcelType === parcelTypes.parcelTypeDoc && ['CDEK'].includes(form.selectedTariff.carrierCode) && form.selectedTariff.isClientCarrier)
    }

    const insuranceCostIsNull = useMemo(() => {
        const valueDeclaredDisabled = getValueDeclaredDisabled(form, parcelTypes);
        return !valueDeclaredDisabled && form.selectedTariff && form.selectedTariff.isClientCarrier;
    }, [form.selectedTariff, form.parcelType])

    useEffect(() => {
        const valueDeclaredDisabled = getValueDeclaredDisabled(form, parcelTypes);
        const carrierExtension = getCarrierUiExtension(form.selectedTariff);

        if (valueDeclaredDisabled || (form.selectedTariff && form.selectedTariff.serviceFee)) {
            changeForm('isValueDeclared', false);
        }

        if (!carrierExtension.isCourierMessageAvailable(form.selectedTariff) && !isDostavistaTariff(form.selectedTariff)) {
            changeForm('senderCommentEnabled', false);
            changeForm('senderComment', '');
        }

        const normalizedContactsPatch = carrierExtension.moveExtraPhonesToAddressComments(form);
        if (normalizedContactsPatch) {
            changeParamsForm(normalizedContactsPatch);
        }

        if (form.selectedTariff) {
            changeForm('saveDisabled', false);
        }

        setSyncTariffDeparture(true);
    }, [form.selectedTariff]);

    useEffect(() => {
        if (syncTariffDeparture) {
            if (form.selectedTariff && form.selectedTariff.departureDate) {
                changeForm('departureDate', new Date(form.selectedTariff.departureDate));
            } else {
                setSyncTariffDeparture(false);
            }
        }
    }, [syncTariffDeparture]);

    useEffect(() => {
        if (syncTariffDeparture) {
            setSyncTariffDeparture(false);
        }
        else if (form.departureDate && step === 4) {
            updateTariffData();
        }
    }, [form.departureDate]);

    useEffect(() => {
        if (form.isValueDeclared && !insuranceCostIsNull) {
            calcInsuranceCost();
        } else {
            changeForm('insuranceCost', 0);
        }
    }, [insuranceCostIsNull, form.parcelType, form.isValueDeclared, form.declaredCargoValue, form.isNoDeclaredValueConfirmation]);

    useEffect(() => {
        setForm(prev => {
            const currentServices = prev.services || {};
            const weight = prev.parcelType === parcelTypes.parcelTypeDoc
                ? Number(prev.documentWeight || 0)
                : Number(prev.cargoWeight || prev.palletsWeight || 0);
            const hasPlaceDimensions = calcByPlacesOn
                && (prev.positions || []).length > 0
                && prev.positions.every(p => p.length && p.width && p.height);
            const nextServices = {...currentServices};
            let changed = false;

            if (weight <= PRR_MAX_WEIGHT_DEFAULT) {
                PRR_SERVICE_CODES.forEach(code => {
                    if (nextServices[code]) {
                        nextServices[code] = false;
                        changed = true;
                    }
                });
            }
            if (!hasPlaceDimensions && nextServices[lathingServiceName]) {
                nextServices[lathingServiceName] = false;
                changed = true;
            }

            return changed ? {...prev, services: nextServices} : prev;
        });
    }, [form.documentWeight, form.cargoWeight, form.palletsWeight, form.positions, calcByPlacesOn]);

    const appliedServicesSignatureRef = useRef('');
    const inflightServicesSignatureRef = useRef(null);

    const runServicesRecalc = () => {
        const currentForm = formRef.current;
        const nextSignature = servicesSignature(currentForm);

        if (nextSignature === appliedServicesSignatureRef.current) {
            return;
        }

        if (onlyMatrixServicesChanged(appliedServicesSignatureRef.current, nextSignature)) {
            // Матричные услуги (ПРП/ПРД/Обрешетка) уже рассчитаны на первом этапе для каждого тарифа.
            // Пересчет с бэкенда не нужен — только фильтруем грид по выбранным услугам и меняем тариф, если текущий не подходит.
            const currentTariffs = tariffsRef.current || [];
            if (currentForm.selectedTariff && !tariffSupportsSelectedServices(currentForm.selectedTariff, currentForm)) {
                const available = currentTariffs
                    .filter(t => tariffSupportsSelectedServices(t, currentForm))
                    .sort((a, b) => (a.cost || 0) - (b.cost || 0));
                changeForm('selectedTariff', available.length ? available[0] : null);
            }
            appliedServicesSignatureRef.current = nextSignature;
            inflightServicesSignatureRef.current = null;
            return;
        }

        const signatureAtStart = nextSignature;
        inflightServicesSignatureRef.current = signatureAtStart;
        setLoadingTariffs(true);
        loadTariffs(true).then((loadedTariffs) => {
            if (step === 4 && currentForm.selectedTariff) {
                const rematch = findTariffAfterDepartureChange(
                    loadedTariffs,
                    currentForm.selectedTariff,
                    currentForm.departureDate
                );
                if (rematch) {
                    changeForm('selectedTariff', rematch);
                }
            }
        }).catch(() => {
        }).finally(() => {
            setLoadingTariffs(false);
            if (inflightServicesSignatureRef.current === signatureAtStart) {
                appliedServicesSignatureRef.current = signatureAtStart;
                inflightServicesSignatureRef.current = null;
            }
        });
    };

    useEffect(() => {
        if (isCalc || !companyId) {
            return;
        }
        if (step !== 3 && step !== 4) {
            return;
        }
        runServicesRecalc();
    }, [servicesSig, isCalc, companyId]);

    const changeForm = (name, value) => {
        if (name !== 'declaredCargoValue') {
            if (errors && Array.isArray(value)) {
                let errs = {...errors};
                value.forEach((p, index) => {
                    typeof p === 'object' && Object.keys(p).forEach(pp => {
                        errs[`${name}.${index}.${pp}`] = null;
                    });
                });

                setErrors(errs);
            }

            if (errors && errors[name]) {
                setErrors(errors => ({
                    ...errors,
                    [name]: null
                }))
            }
        }

        setForm(form => ({
            ...form,
            [name]: value
        }));

    };

    const changeParamsForm = (params) => {
        setForm(form => ({
            ...form,
            ...params
        }));

        setErrors(prev => {
            const errs = {...(prev || {})};
            Object.keys(params).forEach(p => {
                if (p === 'shipmentEmail' || p === 'deliveryEmail') {
                    return;
                }
                errs[p] = null;
                Array.isArray(params[p]) && params[p].forEach((pp, index) => {
                    typeof pp === 'object' && Object.keys(pp).forEach(ppp => {
                        errs[`${p}.${index}.${ppp}`] = null;
                    });
                });
                params[p] && typeof params[p] === 'object' && Object.keys(params[p]).forEach(pp => {
                    errs[`${p}.${pp}`] = null;
                });
            });

            if (Object.prototype.hasOwnProperty.call(params, 'shipmentEmail')) {
                errs.shipmentEmail = null;
            }
            if (Object.prototype.hasOwnProperty.call(params, 'deliveryEmail')) {
                errs.deliveryEmail = null;
            }

            return errs;
        });
    };

    const loadParcelData = (id, isDraft, isCopy) => {
        return apiGet('parcels/' + id)
            .then(data => {
                data.carrierCostRequests = (isDraft && data.carrierId) ? data.carrierCostRequests : null;
                data.selectedTariff = isDraft ? data.selectedTariff : null;

                // Используем departureDate из данных посылки, если оно есть, иначе устанавливаем текущую дату
                if (data.departureDate && !isCopy) {
                    // Парсим дату, учитывая возможные форматы
                    const dateStr = data.departureDate;
                    let parsedDate = null;
                    
                    if (dateStr instanceof Date) {
                        parsedDate = dateStr;
                    } else if (typeof dateStr === 'string') {
                        // Пробуем разные форматы: сначала ISO (YYYY-MM-DD), потом dd.MM.yyyy
                        if (dateStr.includes('T') || /^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
                            // Формат ISO (YYYY-MM-DD или YYYY-MM-DDTHH:mm:ss)
                            const dateOnly = dateStr.split('T')[0];
                            parsedDate = new Date(dateOnly + 'T00:00:00');
                        } else if (/^\d{2}\.\d{2}\.\d{4}/.test(dateStr)) {
                            // Формат dd.MM.yyyy - парсим правильно, чтобы избежать путаницы с MM/dd
                            parsedDate = parse(dateStr, 'dd.MM.yyyy');
                        } else {
                            // Пробуем стандартный парсинг
                            parsedDate = new Date(dateStr);
                        }
                    }
                    
                    // Проверяем валидность даты
                    if (parsedDate && !isNaN(parsedDate.getTime())) {
                        data.departureDate = parsedDate;
                    } else {
                        // Если не удалось распарсить, используем следующий рабочий день
                        data.departureDate = getCurrentOrNextBusinessDay();
                    }
                } else {
                    // Если даты нет, устанавливаем следующий рабочий день
                    data.departureDate = getCurrentOrNextBusinessDay();
                }

                if (isCopy) {
                    data.services = [];
                }

                data.deliveryType = data.deliveryTypeCode;
                data.senderCommentEnabled = !!data.senderComment;

                data.shipmentCity = data.shipmentAddress;
                data.shipmentCountryCode = data.shipmentAddress && data.shipmentAddress.countryCode;

                data.deliveryCity = data.deliveryAddress;
                data.deliveryCountryCode = data.deliveryAddress && data.deliveryAddress.countryCode;

                data.shipmentContactPersonName = data.senderName;
                const shipmentFio = splitContactFio(data.senderName);
                data.shipmentContactLastName = shipmentFio.lastName;
                data.shipmentContactFirstName = shipmentFio.firstName;
                data.shipmentContactPatronymic = shipmentFio.patronymic;
                data.shipmentPhoneNumber = data.senderContactInfo;
                data.shipmentCompany = data.senderCompanyName;
                data.shipmentExt1 = data.senderExt1 || data.senderAdditional; // Доб. Номер1 (EXT.) - добавочный к основному телефону
                data.shipmentAdditionalPhone = data.senderAdditionalPhone;
                data.shipmentExt2 = data.senderExt2;

                data.shipmentEmail = data.senderEmail || '';
                data.shipmentEmailDuplicateToAuthor = !!data.senderEmailDuplicateToAuthor;

                data.deliveryPhoneNumber = data.recipientContactInfo;
                data.deliveryContactPersonName = data.recipientName;
                const deliveryFio = splitContactFio(data.recipientName);
                data.deliveryContactLastName = deliveryFio.lastName;
                data.deliveryContactFirstName = deliveryFio.firstName;
                data.deliveryContactPatronymic = deliveryFio.patronymic;
                data.deliveryCompany = data.recipientCompanyName;
                data.deliveryExt1 = data.recipientExt1 || data.recipientAdditional; // Доб. Номер1 (EXT.) - добавочный к основному телефону
                data.deliveryAdditionalPhone = data.recipientAdditionalPhone;
                data.deliveryExt2 = data.recipientExt2;

                data.deliveryEmail = data.recipientEmail || '';
                data.deliveryEmailDuplicateToAuthor = !!data.recipientEmailDuplicateToAuthor;

                data.cargoPackages = (data.parcelType === parcelTypes.parcelTypePallets) ? data.palletsCount : data.packagesCount;
                if (data.parcelType === parcelTypes.parcelTypeDoc) {
                    data.documentVolume = data.volume;
                    data.documentWeight = data.weight;
                } else if (data.parcelType === parcelTypes.parcelTypePallets) {
                    data.cargoVolume = data.palletsVolume;
                    data.cargoWeight = data.palletsWeight;
                } else {
                    data.cargoVolume = data.volume;
                    data.cargoWeight = data.weight;
                }

                if (data.positions && data.positions.length > 0) {
                    data.positions.forEach((val, ind, arr) => {
                        val.cargoPackages = val.packagesCount;
                    });
                    setCalcByPlacesOn(true);
                } else data.positions = null;

                setCompanyId(data.companyId);

                data.isCopy = true;
                data.click = true;

                const carrierExtension = getCarrierUiExtension(data.selectedTariff);
                const normalizedContactsPatch = carrierExtension.moveExtraPhonesToAddressComments(data);
                if (normalizedContactsPatch) {
                    Object.assign(data, normalizedContactsPatch);
                }

                setForm(data);
            })
            .catch(err => {
                console.log(err)
            });
    }

    useEffect(() => {
        if (copyId || draftId) {
            loadParcelData(copyId || draftId, !!draftId, !!copyId);
            onBeforeUnloadOn();
        } else getLastCountries()
        return () => onBeforeUnloadOff();
    }, []);

    useEffect(() => {
        //автооткрытие на этапе поиска тарифов после получения данных из копируемой посылки
        if ((copyId || draftId) && form.click) {
            setForm(form => {
                delete form.click;
                form.deliveryType = form.deliveryType || (deliveryTypes[0] || {}).value;
                return form;
            });
            onPickUp(true, () => setStep(form.parcelType));
        }
    }, [form.click]);

    useEffect(() => {
        if (!form.isCopy) {
            changeForm('cargoDescription', form.parcelType === parcelTypes.parcelTypeDoc ? 'документы' : null);
        }
    }, [form.parcelType])

    const resetData = () => {
        setConfirmModal({
            open: true,
            label: 'Изменение данных',
            children: 'Вы уверены, что хотите изменить данные по заявке?\n Это приведет к отмене выбранного тарифа.',
            onConfirm: () => {
                setTariffs(null);
                setStep(form.parcelType);
            }
        })
    }

    const getCostModel = (isCalc) => {
        const form = formRef.current;
        const companyData = companyDataRef.current;
        const isPallets = form.parcelType === parcelTypes.parcelTypePallets;
        
        // ВАЖНО: Проверяем, что адреса существуют перед использованием spread оператора
        let shipmentAddress = form.shipmentAddress ? {
            ...form.shipmentAddress,
            postalCode: form.shipmentAddress.postalCode || form.shipmentAddress.estimatedPostalCode
        } : null;
        let deliveryAddress = form.deliveryAddress ? {
            ...form.deliveryAddress,
            postalCode: form.deliveryAddress.postalCode || form.deliveryAddress.estimatedPostalCode
        } : null;
        
        if (isCalc) {
            return {
                onlyCompleteCosts: true,
                hideNames: true,
                from: shipmentAddress,
                to: deliveryAddress,
                take: 3,
                parcelType: isPallets ? parcelTypes.parcelTypeCargo : form.parcelType,
                documentWeight: form.documentWeight,
                weight: isPallets ? form.palletsWeight : form.cargoWeight,
                volume: isPallets ? form.palletsVolume : (form.parcelType === parcelTypes.parcelTypeCargo ? form.cargoVolume : form.documentVolume),
                packages: isPallets ? form.palletsCount : form.cargoPackages
            }
        }

        let positions = form.parcelType !== parcelTypes.parcelTypeDoc
            ? (form.positions || []).map((entry) => ({
                weight: entry.weight,
                length: entry.length,
                width: entry.width,
                height: entry.height,
                packagesCount: entry.cargoPackages
            }))
            : null;
        
        // ВАЖНО: DepartureDate обязательное поле в CarrierCostRequest, всегда должно быть значение
        let departureDateStr = null;
        if (form.departureDate) {
            const date = form.departureDate instanceof Date ? form.departureDate : new Date(form.departureDate);
            if (!isNaN(date.getTime())) {
                departureDateStr = moment(date).format('YYYY-MM-DDTHH:mm:ss');
            }
        }
        // Если дата не установлена, используем сегодняшнюю дату по умолчанию
        if (!departureDateStr) {
            departureDateStr = moment().format('YYYY-MM-DDTHH:mm:ss');
        }
        
        // ВАЖНО: CompanyId обязательное поле в CarrierCostRequest, проверяем что оно установлено
        if (!companyId) {
            console.error('CompanyId is required for cost calculation');
            throw new Error('CompanyId is required');
        }
        
        // ВАЖНО: ParcelType обязательное поле в CarrierCostRequest, проверяем что оно установлено
        if (form.parcelType === undefined || form.parcelType === null) {
            console.error('ParcelType is required for cost calculation');
            throw new Error('ParcelType is required');
        }
        
        // Формируем объект запроса только с валидными данными
        const requestData = {
            onlyCompleteCosts: true,
            companyId: companyId,
            departureDate: departureDateStr,
            parcelType: form.parcelType,
            weight: form.parcelType === parcelTypes.parcelTypeDoc ? (form.documentWeight || 0) : (form.cargoWeight || 0),
            volume: form.parcelType === parcelTypes.parcelTypeCargo ? (form.cargoVolume || 0) : (form.documentVolume || 0),
        };
        
        // Добавляем опциональные поля только если они есть
        if (subCompanyId) {
            requestData.subCompanyId = subCompanyId;
        }
        if (shipmentAddress) {
            requestData.shipmentAddress = shipmentAddress;
        }
        if (deliveryAddress) {
            requestData.deliveryAddress = deliveryAddress;
        }
        if (form.cargoPackages) {
            requestData.packagesCount = form.cargoPackages;
        }
        if (form.deliveryType !== undefined && form.deliveryType !== null) {
            requestData.deliveryTypeCode = String(form.deliveryType);
        }
        if (positions && positions.length > 0) {
            requestData.positions = positions;
        }
        if (form.shipmentPhoneNumber) {
            requestData.senderContactInfo = form.shipmentPhoneNumber;
        }
        if (form.shipmentAdditional) {
            requestData.senderAdditional = form.shipmentAdditional;
        }
        if (form.deliveryPhoneNumber) {
            requestData.recipientContactInfo = form.deliveryPhoneNumber;
        }
        if (form.deliveryAdditional) {
            requestData.recipientAdditional = form.deliveryAdditional;
        }
        
        // Добавляем услуги в запрос
        const services = form.services || {};
        requestData.isReturnRequested = !!services.returnParcel;
        requestData.isReturnDocumentsRequested = !!services.returnDocuments;
        requestData.isLoadingRequested = !!services.loadingUnloading;
        requestData.isPackagingRequested = !!services.additionalPackaging;
        const selectedServices = formServicesArray(form);
        const isCargo = form.parcelType === parcelTypes.parcelTypeCargo || form.parcelType === parcelTypes.parcelTypePallets;
        const matrixServicesToPreload = !isCalc && !!companyData.showExtraServices && isCargo
            ? MATRIX_SERVICE_CODES.filter(code => !selectedServices.includes(code))
            : [];
        requestData.extraServiceCodes = [...new Set([...selectedServices, ...matrixServicesToPreload])];
        
        return requestData;
    }

    const reloadReferences = () => {
        let loadTypes = apiGet('ref/parceltypes/list')
            .then(data => {

                let parcelTypeDoc = 0;
                let parcelTypeCargo = 0;
                data.entries.map((entry, ind, array) => {
                    if (entry.name === "Document") {
                        parcelTypeDoc = entry.id;
                    } else if (entry.name === "Cargo") {
                        parcelTypeCargo = entry.id;
                    }
                });

                setParcelTypes(data => ({
                    ...data,
                    parcelTypeDoc,
                    parcelTypeCargo
                }))
            })
            .catch(err => {
                console.log(err)
            });

        let loadDeliveryTypes = apiGet('ref/deliverytypes/list/')
            .then(data => {

                    setDeliveryTypes(prevState => {
                        prevState = data.entries.map((entry, ind, array) => {
                            if (entry.isDefault) {
                                changeForm('deliveryType', entry.code);
                            }
                            return {
                                value: entry.code,
                                label: entry.name,
                                isDefault: entry.isDefault,
                                hasIntegration: entry.hasIntegration
                            };
                        });
                        return prevState;
                    });

                }
            )
            .catch(err => {
                console.log(err)
            });

        let loadServices = apiGet('ref/carrierServices/list/')
            .then(data => {
                    data.entries && setServices(data.entries.map(e => ({
                        value: e.code,
                        name: e.name,
                        info: e.description
                    })));
                }
            )
            .catch(err => {
                console.log(err)
            });

        return Promise.all([
            loadTypes, loadDeliveryTypes, loadServices
        ]);
    }

    const loadTariffs = (syncState) => {
        changeForm('saveDisabled', false);
        const gen = ++loadTariffsGenerationRef.current;
        const currentForm = formRef.current;
        const requestServicesSignature = servicesSignature(currentForm);
        const deferTariffUiUpdates = inflightServicesSignatureRef.current !== null;
        let result = [];
        let requestData = getCostModel(isCalc);

        return new Promise((resolve, reject) => {
            const finishIfStale = (loadingCount) => {
                if (loadingCount !== 0) {
                    return;
                }
                if (gen === loadTariffsGenerationRef.current) {
                    const finalTariffs = dedupeTariffCosts(result, isCalc);
                    const normalizedTariffs = isCalc
                        ? finalTariffs.map(r => ({...r, displayData: r}))
                        : finalTariffs;
                    if (syncState) {
                        setTariffs(normalizedTariffs);
                    }
                    if (inflightServicesSignatureRef.current === null) {
                        appliedServicesSignatureRef.current = requestServicesSignature;
                    }
                    resolve(normalizedTariffs);
                } else {
                    resolve([]);
                }
            };

            apiGet(!isCalc ? 'parcels/cost/carriers/' + companyId : `carriers/calc/list/?v=${isCalcV2 ? '2' : isTanderCalc ? '3' : '1'}`)
                .then(response => {
                    if (response.entries) {
                        const pvzCarrierName = 'ПВЗ-СДЭК';
                        const hasPvzCarrier = (response.entries || []).some(e => (e && e.name) === pvzCarrierName);
                        setHasPvzCdekCarrier(hasPvzCarrier);
                        const pvzDeliveryTypeCodes = ['4', '5', '6'];
                        const selectedDeliveryTypeCode = currentForm && currentForm.deliveryType != null ? String(currentForm.deliveryType) : '';
                        const isPvzDeliveryType = pvzDeliveryTypeCodes.includes(selectedDeliveryTypeCode);
                        if (!hasPvzCarrier && isPvzDeliveryType) {
                            const defaultDeliveryType = (deliveryTypes || []).find(dt => !pvzDeliveryTypeCodes.includes(String(dt.value)));
                            if (defaultDeliveryType) {
                                changeForm('deliveryType', defaultDeliveryType.value);
                            }
                        }

                        let loadingCount = 0;
                        const entriesToLoad = isPvzDeliveryType
                            ? response.entries.filter(e => (e && e.name) === pvzCarrierName)
                            : response.entries.filter(e => (e && e.name) !== pvzCarrierName);

                        entriesToLoad.forEach((entry, ind, arr) => {
                            if (entry.hasIntegration) {
                                ++loadingCount;
                                apiPost((!isCalc ? 'parcels/cost/calc/' : 'carriers/calc/costs/') + entry.id + (isCalc ? `?v=${isCalcV2 ? '2' : isTanderCalc ? '3' : '1'}` : ''), requestData)
                                    .then(response => {
                                        --loadingCount;
                                        if (gen !== loadTariffsGenerationRef.current) {
                                            finishIfStale(loadingCount);
                                            return;
                                        }
                                        if (!isCalc) {
                                            if (response.costs) {
                                                result = dedupeTariffCosts(result.concat(response.costs), isCalc);
                                                result.sort((a, b) => a.cost - b.cost);
                                                if (syncState && !deferTariffUiUpdates) {
                                                    setTariffs(result);
                                                }
                                            }
                                        } else {
                                            if (response.tariffs) {
                                                result = dedupeTariffCosts(result.concat(response.tariffs), isCalc);
                                                result.sort((a, b) => a.cost - b.cost);
                                                setTariffs(result.map(r => ({...r, displayData: r})));
                                            }
                                        }
                                        finishIfStale(loadingCount);
                                    })
                                    .catch(err => {
                                        --loadingCount;
                                        finishIfStale(loadingCount);
                                    });
                            }
                        });
                        finishIfStale(loadingCount);
                    } else {
                        setHasPvzCdekCarrier(false);
                        if (gen === loadTariffsGenerationRef.current) {
                            resolve(dedupeTariffCosts(result, isCalc));
                        } else {
                            resolve([]);
                        }
                    }
                })
                .catch(err => {
                    setHasPvzCdekCarrier(false);
                    reject(err);
                });
        });
    }

    const npRecalcPvzRef = useRef('');
    const shipmentNpKey = `${(form.shipmentAddress || {}).city || ''}|${(form.shipmentAddress || {}).postalCode || ''}`;
    const deliveryNpKey = `${(form.deliveryAddress || {}).city || ''}|${(form.deliveryAddress || {}).postalCode || ''}`;
    useEffect(() => {
        // Автосброс кодов ПВЗ нужен только на шаге выбора тарифов.
        // На шаге создания (4) это может стирать только что выбранные коды прямо перед сохранением.
        if (step !== 3) return;
        if (!form.selectedTariff) return;
        // Сбрасываем коды ПВЗ только при смене НП/индекса, а не при смене тарифа.
        // Иначе на шаге создания после updateTariffData коды могут очищаться "в фоне".
        const k = `${shipmentNpKey}||${deliveryNpKey}`;
        if (!npRecalcPvzRef.current) {
            npRecalcPvzRef.current = k;
            return;
        }
        if (npRecalcPvzRef.current === k) return;
        npRecalcPvzRef.current = k;
        const t = setTimeout(() => {
            changeParamsForm({
                shipmentPointCode: '',
                deliveryPointCode: ''
            });
            loadTariffs(true).catch(() => {});
        }, 650);
        return () => clearTimeout(t);
    }, [shipmentNpKey, deliveryNpKey, step]);

    useEffect(() => {
        if (step !== 4) {
            return;
        }
        const patch = {};
        ['shipment', 'delivery'].forEach((prefix) => {
            const cityObj = form[`${prefix}City`] || {};
            const addrObj = form[`${prefix}Address`] || {};
            const location = resolvePvzSearchLocation(form, prefix);
            if (!location.city) {
                return;
            }
            const needsAddressCity = !addrObj.city && !addrObj.fullName;
            const needsCitySync = !cityObj.city && !cityObj.fullName;
            if (needsAddressCity || needsCitySync) {
                patch[`${prefix}Address`] = {
                    ...addrObj,
                    ...cityObj,
                    city: location.city
                };
                patch[`${prefix}City`] = {
                    ...cityObj,
                    ...addrObj,
                    city: location.city
                };
            }
        });
        if (Object.keys(patch).length > 0) {
            changeParamsForm(patch);
        }
    }, [
        step,
        form.shipmentCity,
        form.shipmentAddress,
        form.deliveryCity,
        form.deliveryAddress
    ]);

    useEffect(() => {
        if (step < 3) {
            npRecalcPvzRef.current = '';
        }
    }, [step]);

    const validateForm = () => {
        let errors = {};
        const isPositiveNumber = (value) => Number(value) > 0;
        const extractPointCode = (value) => {
            const s = String(value || '').trim();
            if (!s) return '';
            const m = s.match(/([A-ZА-Я0-9-]{3,})/i);
            return m && m[1] ? String(m[1]).toUpperCase() : '';
        };
        const resolvePointCode = (name) => {
            const direct = extractPointCode(form[`${name}PointCode`]);
            if (direct) return direct;
            const fromAddress = extractPointCode((form[`${name}Address`] || {}).pointCode);
            if (fromAddress) return fromAddress;
            const fromComment = extractPointCode(form[`${name}AddressComment`]);
            return fromComment || '';
        };

        if ((step === parcelTypes.parcelTypeCargo || step === parcelTypes.parcelTypeDoc || step === parcelTypes.parcelTypePallets) && !(form.shipmentAddress || {}).fullName || !(form.deliveryAddress || {}).fullName) {
            const textError = `Пожалуйста, укажите адрес ${!(form.shipmentAddress || {}).fullName ? 'отправления' : 'доставки'}`;
            toast.error(textError);
            errors[!(form.shipmentAddress || {}).fullName ? 'shipmentAddress' : 'deliveryAddress'] = textError;
        }

        if ((step === parcelTypes.parcelTypeCargo || step === parcelTypes.parcelTypeDoc) && ((form.shipmentAddress || {}).fullName
                && (!(form.shipmentAddress || {}).postalCode && !(form.shipmentAddress || {}).estimatedPostalCode && !(form.shipmentAddress || {}).isIndexCanBeEmpty))
            || ((form.deliveryAddress || {}).fullName && (!(form.deliveryAddress || {}).postalCode && !(form.deliveryAddress || {}).estimatedPostalCode && !(form.deliveryAddress || {}).isIndexCanBeEmpty))) {
            errors[(form.shipmentAddress || {}).fullName && (!(form.shipmentAddress || {}).postalCode && !(form.shipmentAddress || {}).estimatedPostalCode && !(form.shipmentAddress || {}).isIndexCanBeEmpty)
                ? 'shipmentAddress' : 'deliveryAddress'] = postalCodeErrorText;
            toast.error(postalCodeErrorText)
        }

        if (step === parcelTypes.parcelTypePallets) {
            if (!isPositiveNumber(form.palletsVolume)) {
                errors['palletsVolume'] = 'Объем должен быть больше 0';
            }
            if (!isPositiveNumber(form.palletsWeight)) {
                errors['palletsWeight'] = 'Вес должен быть больше 0';
            }
            if (!isPositiveNumber(form.palletsCount)) {
                errors['palletsCount'] = 'Кол-во паллет должно быть больше 0';
            }
            if (!form.cargoDescription || form.cargoDescription.trim() === '') {
                errors['cargoDescription'] = 'Не введено описание содержимого';
            }
        }

        if (step === parcelTypes.parcelTypeCargo || (form.parcelType === parcelTypes.parcelTypeCargo && step === 4)) {

            if (calcByPlacesOn) {
                (form.positions || [{}]).forEach((pos, index) => {
                    if (!isPositiveNumber(pos.height)) errors[`positions.${index}.height`] = 'Высота должна быть больше 0';
                    if (!isPositiveNumber(pos.length)) errors[`positions.${index}.length`] = 'Длина должна быть больше 0';
                    if (!isPositiveNumber(pos.weight)) errors[`positions.${index}.weight`] = 'Вес должен быть больше 0';
                    if (!isPositiveNumber(pos.width)) errors[`positions.${index}.width`] = 'Ширина должна быть больше 0';
                    if (!isPositiveNumber(pos.cargoPackages)) errors[`positions.${index}.cargoPackages`] = 'Кол-во мест должно быть больше 0';
                });
            } else {
                if (!isPositiveNumber(form.cargoVolume)) {
                    errors['cargoVolume'] = 'Объем должен быть больше 0';
                }
                if (!isPositiveNumber(form.cargoWeight)) {
                    errors['cargoWeight'] = 'Вес должен быть больше 0';
                }
                if (!isPositiveNumber(form.cargoPackages)) {
                    errors['cargoPackages'] = 'Кол-во мест должно быть больше 0';
                }
            }
            
            // Обязательная проверка cargoDescription для всех случаев типа Груз
            if (!form.cargoDescription || (typeof form.cargoDescription === 'string' && form.cargoDescription.trim() === '')) {
                errors['cargoDescription'] = 'Не введено описание содержимого';
            }
        }

        if (step === parcelTypes.parcelTypeDoc || (form.parcelType === parcelTypes.parcelTypeDoc && step === 4)) {
            if (!isPositiveNumber(form.documentWeight)) {
                errors['documentWeight'] = 'Вес должен быть больше 0';
            } else if (Number(form.documentWeight) > DOCUMENT_MAX_WEIGHT) {
                errors['documentWeight'] = 'Большое количество документов считается грузом. Измените тип посылки на Груз.';
            }
            if (!form.cargoDescription || form.cargoDescription.trim() === '') {
                errors['cargoDescription'] = 'Не введено описание содержимого';
            }
        }

        if (step === 4) {
            const livePayerErrors = payerValidateRef.current ? payerValidateRef.current() : payerTabErrors;
            if (livePayerErrors) {
                errors = {...errors, ...livePayerErrors};
            }
            const deliveryTypeCode = String(form.deliveryType || '');
            const pvzCarrierName = 'ПВЗ-СДЭК';
            const isPvzCarrier = (form.selectedTariff || {}).carrierName === pvzCarrierName;
            const cdekShipmentPointRequired = isPvzCarrier && ['4', '6'].includes(deliveryTypeCode);
            const cdekDeliveryPointRequired = isPvzCarrier && ['5', '6'].includes(deliveryTypeCode);

            if (!form.shipmentAddress || (form.shipmentAddress && !form.shipmentAddress.city)) {
                errors['shipmentAddress.city'] = 'Не введен населенный пункт отправления';
            }
            if (!cdekShipmentPointRequired && form.shipmentAddress && (((!form.shipmentAddress.street || !form.shipmentAddress.house) && !form.shipmentAddress.postalCode)
                || (!form.shipmentAddress.street && !form.shipmentAddress.house && form.shipmentAddress.postalCode))) {
                if ((!form.shipmentAddress.street && !form.shipmentAddress.postalCode) || form.shipmentAddress.postalCode) errors['shipmentAddress.street'] = 'Не введена улица в населенном пункте отправления';
                if (form.shipmentAddress.street && !form.shipmentAddress.postalCode) errors['shipmentAddress.house'] = 'Не введен дом в населенном пункте отправления';
            }
            if (!cdekDeliveryPointRequired && form.deliveryAddress && (((!form.deliveryAddress.street || !form.deliveryAddress.house) && !form.deliveryAddress.postalCode)
                || (!form.deliveryAddress.street && !form.deliveryAddress.house && form.deliveryAddress.postalCode))) {
                if ((!form.deliveryAddress.street && !form.deliveryAddress.postalCode) || form.deliveryAddress.postalCode) errors['deliveryAddress.street'] = 'Не введена улица в населенном пункте доставки';
                if (form.deliveryAddress.street && !form.deliveryAddress.postalCode) errors['deliveryAddress.house'] = 'Не введен дом в населенном пункте доставки';
            }
            if (!form.deliveryAddress || (form.deliveryAddress && !form.deliveryAddress.city)) {
                errors['deliveryAddress.city'] = 'Не введен населенный пункт доставки';
            }
            const shipmentPointCodeResolved = resolvePointCode('shipment');
            const deliveryPointCodeResolved = resolvePointCode('delivery');

            if (cdekShipmentPointRequired && !shipmentPointCodeResolved) {
                errors['shipmentPointCode'] = 'Не указан код ПВЗ отправления';
                toast.error('Не указан код ПВЗ отправления');
            }
            if (cdekDeliveryPointRequired && !deliveryPointCodeResolved) {
                errors['deliveryPointCode'] = 'Не указан код ПВЗ доставки';
                toast.error('Не указан код ПВЗ доставки');
            }
            if (cdekShipmentPointRequired) {
                if (!form.shipmentContactLastName || !String(form.shipmentContactLastName).trim()) {
                    errors['shipmentContactLastName'] = 'Не введена фамилия отправителя';
                }
                if (!form.shipmentContactFirstName || !String(form.shipmentContactFirstName).trim()) {
                    errors['shipmentContactFirstName'] = 'Не введено имя отправителя';
                }
            } else if (!form.shipmentContactPersonName) {
                errors['shipmentContactPersonName'] = 'Не введено контактное лицо отправления';
            }
            if (cdekDeliveryPointRequired) {
                if (!form.deliveryContactLastName || !String(form.deliveryContactLastName).trim()) {
                    errors['deliveryContactLastName'] = 'Не введена фамилия получателя';
                }
                if (!form.deliveryContactFirstName || !String(form.deliveryContactFirstName).trim()) {
                    errors['deliveryContactFirstName'] = 'Не введено имя получателя';
                }
            } else if (!form.deliveryContactPersonName) {
                errors['deliveryContactPersonName'] = 'Не введено контактное лицо доставки';
            }
            if (!form.shipmentPhoneNumber || findPhoneNumbersInText(form.shipmentPhoneNumber).length === 0) {
                errors['shipmentPhoneNumber'] = 'Не введен телефон отправления';
            }
            if (!form.deliveryPhoneNumber || findPhoneNumbersInText(form.deliveryPhoneNumber).length === 0) {
                errors['deliveryPhoneNumber'] = 'Не введен телефон доставки';
            }
            if (cdekShipmentPointRequired && form.shipmentEmail) {
                const emailError = getEmailValidationError(form.shipmentEmail);
                if (emailError) {
                    errors['shipmentEmail'] = emailError;
                }
            }
            if (cdekDeliveryPointRequired && form.deliveryEmail) {
                const emailError = getEmailValidationError(form.deliveryEmail);
                if (emailError) {
                    errors['deliveryEmail'] = emailError;
                }
            }
            if (form.isValueDeclared && !form.declaredCargoValue) {
                errors['declaredCargoValue'] = 'Не введена сумма страхования';
            }
            if (form.selectedTariff && form.selectedTariff.isRecipientCompanyRequired) {
                if (!form.recipientInn) {
                    errors['recipientInn'] = 'Не введен ИНН получателя';
                }
                if (!form.deliveryCompany) {
                    errors['deliveryCompany'] = 'Не введено юр.лицо получателя';
                }
            }
            
            // Валидация для FlipPost - ограничение длины полей до 50 символов
            if (form.selectedTariff && ['FlipPost'].includes(form.selectedTariff.carrierCode)) {
                if (form.deliveryCompany && form.deliveryCompany.length > 50) {
                    errors['deliveryCompany'] = 'Название компании получателя не должно превышать 50 символов';
                }
                if (form.deliveryContactPersonName && form.deliveryContactPersonName.length > 50) {
                    errors['deliveryContactPersonName'] = 'Контактное лицо получателя не должно превышать 50 символов';
                }
                if (form.deliveryWarehouseName && form.deliveryWarehouseName.length > 50) {
                    errors['deliveryWarehouseName'] = 'Точка доставки не должна превышать 50 символов';
                }
            }

            // Валидация для КСЭ - ограничение длины комментариев к адресам до 100 символов
            if (form.selectedTariff && (form.selectedTariff.carrierCode === 'CSE' || 
                (form.selectedTariff.carrierCode && (form.selectedTariff.carrierCode.includes('КСЭ') || form.selectedTariff.carrierCode.includes('Cse'))))) {
                if (form.shipmentAddressComment && form.shipmentAddressComment.length > 100) {
                    errors['shipmentAddressComment'] = ADDRESS_COMMENT_CARRIER_LIMIT_MESSAGE;
                }
                if (form.deliveryAddressComment && form.deliveryAddressComment.length > 100) {
                    errors['deliveryAddressComment'] = ADDRESS_COMMENT_CARRIER_LIMIT_MESSAGE;
                }
                if (errors.shipmentAddressComment || errors.deliveryAddressComment) {
                    errors.messageText = ADDRESS_COMMENT_CARRIER_LIMIT_MESSAGE;
                }
            }
            
            if (form.selectedTariff && ['CDEK'].includes(form.selectedTariff.carrierCode)) {
                const message = 'Проверьте корректность внесения телефона. Правильный формат: +79991234567. Добавочный номер требуется внести в поле "Добавочный"'
                if (form.shipmentPhoneNumber && containsAnyLetter(form.shipmentPhoneNumber)) {
                    errors['shipmentPhoneNumber'] = 'Телефон некорректен';
                    errors.messageText = message;
                }
                if (form.deliveryPhoneNumber && containsAnyLetter(form.deliveryPhoneNumber)) {
                    errors['deliveryPhoneNumber'] = 'Телефон некорректен';
                    errors.messageText = message;
                }
            }

            if (form.selectedTariff
                && form.selectedTariff.carrierCode === 'Dostavista'
                && form.senderCommentEnabled
                && (form.senderComment || '').length > 50) {
                errors['senderComment'] = 'Короткое сообщение курьеру не должно превышать 50 символов';
            }
        }

        return Object.keys(errors).length > 0 ? errors : null;
    }

    const getParcelModel = (isReadyToSend = true, sendOverrides = null) => {
        let currentUserId = getCurrentUserId();
        const selectedTariff = (sendOverrides && sendOverrides.selectedTariff) || form.selectedTariff;
        const tariffsForSave = (sendOverrides && sendOverrides.tariffs) || tariffs;
        const extractPointCode = (value) => {
            const s = String(value || '').trim();
            if (!s) return '';
            const m = s.match(/([A-ZА-Я0-9-]{3,})/i);
            return m && m[1] ? String(m[1]).toUpperCase() : '';
        };
        const resolvePointCode = (name) => {
            const direct = extractPointCode(form[`${name}PointCode`]);
            if (direct) return direct;
            const fromAddress = extractPointCode((form[`${name}Address`] || {}).pointCode);
            if (fromAddress) return fromAddress;
            const fromComment = extractPointCode(form[`${name}AddressComment`]);
            return fromComment || '';
        };
        const shipmentPointCodeResolved = resolvePointCode('shipment');
        const deliveryPointCodeResolved = resolvePointCode('delivery');
        const deliveryTypeCode = String(form.deliveryType || '');
        const isPvzCarrier = (selectedTariff || {}).carrierName === 'ПВЗ-СДЭК';
        const cdekShipmentPointRequired = isPvzCarrier && ['4', '6'].includes(deliveryTypeCode);
        const cdekDeliveryPointRequired = isPvzCarrier && ['5', '6'].includes(deliveryTypeCode);
        let positions = form.parcelType === parcelTypes.parcelTypeCargo ? (form.positions || []).map((entry) => ({
            weight: entry.weight,
            length: entry.length,
            width: entry.width,
            height: entry.height,
            packagesCount: entry.cargoPackages
        })) : null;
        const carrierCostRequests = !tariffsForSave
            ? form.carrierCostRequests
            : buildCarrierCostRequests(tariffsForSave, selectedTariff);
        return {
            cargoDescription: form.cargoDescription,
            carrierId: selectedTariff && selectedTariff.carrierId,
            deliveryTypeCode: form.deliveryType,
            deliveryType: form.deliveryType,
            deliveryTime: null,
            departureDate: form.departureDate ? moment(form.departureDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            initialPlannedDepartureDate: form.initialPlannedDepartureDate ? moment(form.initialPlannedDepartureDate).format('YYYY-MM-DDTHH:mm:ss') : (form.departureDate ? moment(form.departureDate).format('YYYY-MM-DDTHH:mm:ss') : null),
            initialPlannedDeliveryDate: form.initialPlannedDeliveryDate ? moment(form.initialPlannedDeliveryDate).format('YYYY-MM-DDTHH:mm:ss') : ((selectedTariff && selectedTariff.maxDeliveryTime) ? moment(selectedTariff.maxDeliveryTime).format('YYYY-MM-DDTHH:mm:ss') : null),
            //isDeliveryTimeSpecified: false,
            //isLoadingRequested: false,
            //isPackagingRequested: false,
            //packagingComment: "",
            //isProductSending: false,
            //isReturnRequested: false,
            isValueDeclared: form.isValueDeclared,
            // isTempConditionRequested: false,
            parcelType: form.parcelType,
            // senderComment: "",
            senderComment: (selectedTariff
                && (getCarrierUiExtension(selectedTariff).isCourierMessageAvailable(selectedTariff) || isDostavistaTariff(selectedTariff))
                && form.senderCommentEnabled)
                ? form.senderComment
                : null,
            tempConditionHigh: form.tempConditionHigh,
            tempConditionLow: form.tempConditionLow,
            deliveryCost: selectedTariff && (
                (selectedTariff.cost || 0)
                + (selectedTariff.serviceFee || 0)
                + formServicesArray(form).reduce((sum, s) => {
                    const extraCost = Number.parseFloat(serviceTariff(s, {selectedTariff}).cost);
                    return sum + (Number.isNaN(extraCost) ? 0 : extraCost);
                }, 0)
            ),
            rawDeliveryCost: selectedTariff && (selectedTariff.rawCost + (selectedTariff.serviceFee || 0)),
            // costPrice: null,
            tariffRate: form.tariffRate,
            // externalNumber: '',
            declaredCargoValue: form.isValueDeclared ? form.declaredCargoValue : null,
            // actualDeliveryCost: null,
            carrierServiceCode: selectedTariff && selectedTariff.carrierServiceCode,
            vehicleTypeId: form.vehicleTypeId,
            packagesCount: form.cargoPackages,
            volume: form.parcelType === parcelTypes.parcelTypeCargo ? form.cargoVolume : form.documentVolume,
            weight: form.parcelType === parcelTypes.parcelTypeDoc ? form.documentWeight : form.cargoWeight,
            volumeWeight: calcWeight(form),

            shipmentAddressId: form.shipmentAddress && form.shipmentAddress.id,
            shipmentAddress: form.shipmentAddress,
            shipmentCityId: form.shipmentCity && form.shipmentCity.id,
            shipmentPointCode: shipmentPointCodeResolved || null,
            shipmentAddressComment: form.shipmentAddressComment,

            deliveryAddressId: form.deliveryAddress && form.deliveryAddress.id,
            deliveryCityId: form.deliveryCity && form.deliveryCity.id,
            deliveryAddress: form.deliveryAddress,
            deliveryPointCode: deliveryPointCodeResolved || null,
            deliveryAddressComment: form.deliveryAddressComment,
            // senderId: null,
            senderName: resolveContactPersonName(
                form.shipmentContactPersonName,
                form.shipmentContactLastName,
                form.shipmentContactFirstName,
                form.shipmentContactPatronymic,
                cdekShipmentPointRequired
            ),
            senderContactInfo: form.shipmentPhoneNumber ? form.shipmentPhoneNumber : null,
            senderAdditional: form.shipmentExt1 ? form.shipmentExt1 : null, // Старое поле для обратной совместимости (заполняется из Ext1)
            senderExt1: form.shipmentExt1 ? form.shipmentExt1 : null, // Доб. Номер1 (EXT.) - добавочный к основному телефону
            senderAdditionalPhone: form.shipmentAdditionalPhone ? form.shipmentAdditionalPhone : null,
            senderExt2: form.shipmentExt2 ? form.shipmentExt2 : null,
            senderEmail: form.shipmentEmail ? String(form.shipmentEmail).trim() : null,
            senderEmailDuplicateToAuthor: !!form.shipmentEmailDuplicateToAuthor && !!String(form.shipmentEmail || '').trim(),
            senderCompanyName: form.shipmentCompany,
            // recipientUserId: null,
            recipientContactInfo: form.deliveryPhoneNumber ? form.deliveryPhoneNumber : null,
            recipientAdditional: form.deliveryExt1 ? form.deliveryExt1 : null, // Старое поле для обратной совместимости (заполняется из Ext1)
            recipientExt1: form.deliveryExt1 ? form.deliveryExt1 : null, // Доб. Номер1 (EXT.) - добавочный к основному телефону
            recipientAdditionalPhone: form.deliveryAdditionalPhone ? form.deliveryAdditionalPhone : null,
            recipientExt2: form.deliveryExt2 ? form.deliveryExt2 : null,
            recipientEmail: form.deliveryEmail ? String(form.deliveryEmail).trim() : null,
            recipientEmailDuplicateToAuthor: !!form.deliveryEmailDuplicateToAuthor && !!String(form.deliveryEmail || '').trim(),
            recipientInn: form.recipientInn,
            recipientName: resolveContactPersonName(
                form.deliveryContactPersonName,
                form.deliveryContactLastName,
                form.deliveryContactFirstName,
                form.deliveryContactPatronymic,
                cdekDeliveryPointRequired
            ),
            recipientCompanyName: form.deliveryCompany,
            // shipmentPointContactInfoId: null,
            // deliveryPointContactInfoId: null,
            companyId,
            subCompanyId: form.subCompanyId || subCompanyId,
            // shipmentTypeId: null,
            // shipmentPurposeId: null,
            // productId: null,
            // regionId: null,
            // costCenterId: null,
            // glAccountId: null,
            // userCompanyId: null,
            isReadyToSend,
            carrierCostRequests,
            // claimId: null,
            // version: null,
            // isExternal: true,
            // isConfirmed: false,
            insuranceCost: form.insuranceCost,
            serviceFee: selectedTariff && selectedTariff.serviceFee,
            isNoDeclaredValueConfirmation: form.isNoDeclaredValueConfirmation,
            allStatusNotifications: form.allStatusNotifications,
            positions,
            services: formServicesArray(form),
            source: form.source || (!!copyId ? 2 : 1), // Сохраняем исходный источник, если он есть (для массовой загрузки)
            draftParcelId: draftId,

            //для блока Плательщик
            initiatorId: form.initiatorId ? form.initiatorId : currentUserId,
            isCrossSector: form.isCrossSector,
            initiatorIsCrossSector: form.initiatorIsCrossSector,
            initiatorSubCompanyId: form.initiatorSubCompanyId,
            shipmentTypeId: form.shipmentTypeId,
            shipmentPurposeId: form.shipmentPurposeId,
            productId: form.productId,
            activityCode: form.activityCode,
            regionId: form.regionId,
            regionCode: form.regionCode,
            costCenterId: form.costCenterId,
            parcelCustomerId: form.parcelCustomerId || null,
            glAccountId: form.glAccountId,
            userCompanyId: form.userCompanyId,
            massUploadFileId: form.massUploadFileId || null, // ID файла массовой загрузки (если посылка создана через массовую загрузку)
        };
    }

    const formatCost = (value) => {
        if (value) {
            return value.toFixed(2);
        } else {
            return '0.00';
        }
    }

    const saveDraft = () => {
        // Показываем кастомное модальное окно вместо стандартного браузерного
        setConfirmModal({
            open: true,
            label: 'Сохранение черновика',
            children: 'Вы хотите сохранить черновик и выйти?',
            confirmBtnLabel: 'Сохранить и выйти',
            closeBtnLabel: 'Остаться',
            onConfirm: () => {
                // Отключаем стандартное браузерное окно и Prompt перед навигацией
                onBeforeUnloadOff();
                setIsSaved(true);
                setLoadingDraftSave(true);
                let parcelData = getParcelModel(false);
                apiPut('parcels/new', parcelData)
                    .then(() => {
                        setLoadingDraftSave(false);
                        history.push('/parcels/list');
                    })
                    .catch(e => {
                        console.log(e);
                        toast.error('Произошла ошибка')
                        setLoadingDraftSave(false);
                        // Включаем обратно предупреждение при ошибке
                        if (draftId || copyId) {
                            onBeforeUnloadOn();
                            setIsSaved(false);
                        }
                    });
            },
            onClose: () => {
                // При нажатии "Остаться" просто закрываем модальное окно
                // Пользователь остается на текущей странице
                setConfirmModal(null);
            }
        });
    }

    const sendParcelRequest = (completeCallback, isCreatedByManagedPaid = false, sendOverrides = null) => {
        let parcelData = getParcelModel(true, sendOverrides);
        parcelData.isConfirmed = true;
        parcelData.isCreatedByManagedPaid = isCreatedByManagedPaid;

        apiPut('parcels/new', parcelData)
            .then(data => {
                let parcelId = data.parcelId;
                completeCallback && completeCallback();

                changeParamsForm({
                    parcelId
                })
                onBeforeUnloadOff();
                setIsSaved(true);
                const carrierCode = ((sendOverrides && sendOverrides.selectedTariff) || form.selectedTariff || {}).carrierCode;
                history.push({
                    pathname: '/parcels/' + parcelId,
                    hash: '#docs',
                }, ['PE', 'CDEK'].includes(carrierCode) ? {
                    info: 'Документы по отправлению будут опубликованы на этой странице  в течение 10 минут'
                } : null);
            })
            .catch(errors => {
                let parcelId = errors.parcelId;
                completeCallback && completeCallback();

                let errorMessage = 'Произошла ошибка';
                if (errors && errors.validationResult && errors.validationResult.messages) {
                    let errorMessages = errors && errors.validationResult && errors.validationResult.messages;
                    errorMessage = (Object.keys(errorMessages).map(key => errorMessages[key])).join('; ');
                    const normalizedErrors = {};
                    Object.keys(errorMessages).forEach(key => {
                        normalizedErrors[key.charAt(0).toLowerCase() + key.slice(1)] = errorMessages[key];
                    });
                    setErrors(normalizedErrors);
                    setPayerTabErrors(normalizedErrors);
                }

                if (parcelId) {
                    toast.error(errorMessage);
                    onBeforeUnloadOff();
                    setIsSaved(true);

                    if (errors.hasWarnings) {
                        setConfirmModal({
                            open: true,
                            label: 'Заказ отправления',
                            children: errorMessage,
                            hideConfirm: true,
                            closeBtnLabel: 'Ок',
                            onClose: () => {
                                changeParamsForm({
                                    parcelId
                                });
                                history.push({
                                    pathname: '/parcels/' + parcelId,
                                    hash: '#history'
                                });
                            }
                        });
                    } else {
                        changeParamsForm({
                            parcelId
                        });
                        history.push({
                            pathname: '/parcels/' + parcelId,
                            hash: '#history'
                        });
                    }
                } else {
                    // Ошибка без parcelId должна быть явно видна пользователю,
                    // иначе создается впечатление "вечной" загрузки.
                    toast.error(errorMessage);
                }
            });
    }

    const confirmParcelCreation = (sendOverrides = null) => {
        if (isCoordinator) {
            setConfirmModal({
                open: true,
                label: 'Стоимость за создание отправления',
                children: 'Выставить клиенту сумму за создание заказа клиентским менеджером?',
                onConfirm: () => sendParcelRequest(() => setLoadingCreate(false), true, sendOverrides),
                onClose: () => sendParcelRequest(() => setLoadingCreate(false), false, sendOverrides)
            })
        } else {
            sendParcelRequest(() => setLoadingCreate(false), false, sendOverrides);
        }
    };

    const createParcel = () => {
        if (companyData.contractStatus !== 1 && companyData.contractStatus !== 3) {
            let message = (<span>Для размещения заказов требуется <a href={getPoolingContractsUrl()} target="_blank">подписание договора</a>.</span>);
            if (companyData.contractStatus == 2) {
                message = (<span>Ваш договор заблокирован. Обратитесь в поддержку или к вашему клиентскому менеджеру.</span>);
            }
            setConfirmModal({
                open: true,
                label: 'Создание отправления',
                children: message,
                hideClose: true,
                confirmBtnLabel: 'Ok'
            });
            return;
        }
        setLoadingCreate(true);
        let errors = validateForm();
        if (errors) {
            setErrors(errors);
            if (errors.messageText) {
                toast.error(errors.messageText);
            } else {
                toast.error('Заполните все обязательные поля');
            }
            setLoadingCreate(false);
        } else {
            updateTariffData(
                (oldCost, newCost, tariff, nextTariffs) => {
                    const sendOverrides = {selectedTariff: tariff, tariffs: nextTariffs};
                    if (oldCost && newCost && oldCost !== newCost) {
                        setConfirmModal({
                            open: true,
                            label: 'Изменение стоимости доставки',
                            children: 'Стоимость доставки изменилась с ' + formatCost(oldCost) + ' на ' + formatCost(newCost) + '. Вы хотите заказать доставку по новой цене?',
                            onConfirm: () => confirmParcelCreation(sendOverrides),
                            onClose: () => {
                                setLoadingCreate(false);
                                setConfirmModal(null);
                            }
                        })
                    } else {
                        confirmParcelCreation(sendOverrides);
                    }
                },
                () => setLoadingCreate(false),
                { isOrderRecheck: true }
            );
        }
    }

    const onFindTariffsByCities = () => {
        setLoadingTariffs(true);

        loadTariffs(true)
            .then(() => {
                setLoadingTariffs(false);
            })
            .catch(err => {
                setLoadingTariffs(false);
            });
    }


    const onPickUp = (noLoad, errorCallback) => {
        if (isCalcV2) ym(49255948, 'reachGoal', 'click-tariffs')
        if (form.parcelType === parcelTypes.parcelTypeDoc && Number(form.documentWeight) > DOCUMENT_MAX_WEIGHT) {
            setConfirmModal({
                open: true,
                label: 'Тип посылки',
                children: (
                    <div>
                        <div>Большое количество документов считается грузом.</div>
                        <div>Измените тип посылки на Груз.</div>
                    </div>
                ),
                confirmBtnLabel: 'ОК',
                hideClose: true,
                onConfirm: () => setConfirmModal(null)
            });
            errorCallback && errorCallback();
            return;
        }
        let errs = validateForm();
        if (errs) {
            setErrors(errs);
            if (errs.messageText) {
                toast.error(errs.messageText);
            } else {
                toast.error('Необходимо заполнить все поля со "звездочкой" (*).');
            }
            errorCallback && errorCallback()
            return;
        } else {

            setErrors({});
            setStep(3);
            setTariffs([]);

            !noLoad && onFindTariffsByCities();
        }
    }


    const [weekdays, setWeekdays] = useState([]);

    const postalCodeErrorText = 'Укажите полный адрес';

    const getGates = () => {
        let startDate = new Date();
        let endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        apiPost('ref/dayoffs/list', {
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD')
        }).then(r => {
            setWeekdays(r.entries)
        })
    }

    useEffect(() => {
        getGates();
        reloadReferences();
    }, [])

    const handleAddressSelect = (name, value, withoutCity) => {
        if (name.includes('parcelType')) {
            changeForm(name, value);
            // Автоматически включаем "расчёт по местам" при выборе типа груза
            if (value === parcelTypes.parcelTypeCargo) {
                setCalcByPlacesOn(true);
                changeForm('positions', [{cargoPackages: 1}]);
            } else {
                // Сбрасываем "расчёт по местам" для других типов отправления
                setCalcByPlacesOn(false);
                changeForm('positions', null);
            }
        } else {
            let item = {...value};
            const contactFio = splitContactFio(item.contactName);
            let values = {
                [`${name}Address`]: item,
                [`${name}ContactPersonName`]: item.contactName,
                [`${name}ContactLastName`]: contactFio.lastName,
                [`${name}ContactFirstName`]: contactFio.firstName,
                [`${name}ContactPatronymic`]: contactFio.patronymic,
                [`${name}Company`]: item.companyName,
                [`${name}PhoneNumber`]: item.contactPhone,
                [`${name}Additional`]: item.additionalPhone,
                [`${name}Ext1`]: item.additionalPhone,
                [`${name}AdditionalPhone`]: item.additionalPhone2,
                [`${name}Ext2`]: item.ext2,
                [`${name}AddressComment`]: item.comment
            };

            if (!withoutCity) values[`${name}City`] = item;

            if (item.countryCode) values[`${name}CountryCode`] = item.countryCode;
            const carrierExtension = getCarrierUiExtension(form.selectedTariff);
            if (carrierExtension.usePrimaryPhoneOnly(form.selectedTariff)) {
                const mergedForm = {
                    ...form,
                    ...values
                };
                const normalizedContactsPatch = carrierExtension.moveExtraPhonesToAddressComments(mergedForm);
                if (normalizedContactsPatch) {
                    values = {
                        ...values,
                        ...normalizedContactsPatch
                    };
                }
            }
            changeParamsForm(values);

            const addressError = item.fullName && (!item.postalCode && !item.estimatedPostalCode && !item.isIndexCanBeEmpty);
            setErrors(errors => ({
                ...(errors || {}),
                [`${name}Address`]: addressError ? postalCodeErrorText : null
            }));
            addressError && toast.error(postalCodeErrorText);
        }
    }

    const updateTariffData = (callback, callbackFailed, options = null) => {
        changeForm('saveDisabled', false);
        if (step === 4) {
            const selectedTariff = form.selectedTariff;
            if (!selectedTariff || !selectedTariff.carrierId) {
                // Если нет выбранного тарифа, перезагружаем все тарифы
                loadTariffs(true).then(() => {
                    setLoadingTariffs(false);
                    callbackFailed && callbackFailed();
                }).catch(() => {
                    setLoadingTariffs(false);
                    callbackFailed && callbackFailed();
                });
                return false;
            }
            
            setLoadingTariffs(true);
            let requestData = getCostModel();
            // Только финальный пересчёт перед «Заказать» — без «на завтра» и без возврата, если он не выбран.
            if (options && options.isOrderRecheck) {
                requestData.isOrderRecheck = true;
            }
            
            // Проверяем, что departureDate передается корректно
            if (!requestData.departureDate) {
                requestData.departureDate = form.departureDate ? moment(form.departureDate).format('YYYY-MM-DDTHH:mm:ss') : null;
            }

            const applyFoundTariff = (tariff, sourceList) => {
                const nextTariffs = mergeSelectedTariffIntoList(sourceList || tariffs, selectedTariff, tariff);
                changeForm('selectedTariff', tariff);
                setTariffs(nextTariffs);
                setLoadingTariffs(false);
                callback && callback(selectedTariff && selectedTariff.cost, tariff.cost, tariff, nextTariffs);
                return true;
            };

            apiPost('parcels/cost/calc/' + selectedTariff.carrierId, requestData).then(res => {
                const responseTariffs = res.costs || [];
                const tariff = findTariffAfterDepartureChange(
                    responseTariffs,
                    selectedTariff,
                    form.departureDate
                );

                if (tariff) {
                    return applyFoundTariff(tariff, tariffs);
                }

                // Если тариф не найден у выбранной ТК — перезагружаем все и пробуем автовыбор
                loadTariffs(true).then((loadedTariffs) => {
                    const rematch = findTariffAfterDepartureChange(
                        loadedTariffs,
                        selectedTariff,
                        form.departureDate
                    );
                    if (rematch) {
                        applyFoundTariff(rematch, loadedTariffs);
                        return;
                    }
                    changeForm('selectedTariff', null);
                    changeForm('saveDisabled', true);
                    setLoadingTariffs(false);
                    toast.warning('Для выбранной даты тариф не найден. Пожалуйста, выберите тариф из обновленного списка.');
                    callbackFailed && callbackFailed();
                }).catch(() => {
                    changeForm('selectedTariff', null);
                    changeForm('saveDisabled', true);
                    toast.error('Для введенных данных отсутствует тариф в выбранной транспортной компании');
                    setLoadingTariffs(false);
                    callbackFailed && callbackFailed();
                });
                return false;
            }).catch(e => {
                toast.error('Произошла ошибка при обновлении тарифов');
                setLoadingTariffs(false);
                callbackFailed && callbackFailed();
            });
            return;
        }

        callbackFailed && callbackFailed();
    };

    const saveDraftBtn = <Button
        disabled={loadingDraftSave}
        loading={loadingDraftSave}
        className='modal__btn-cancel m-t-16'
        onClick={() => {
            saveDraft()
        }}
    >
        Сохранить для доработки
    </Button>

    return (
        <div className={`new ${isCalc ? 'new-calc' : ''}`}>
            <Segment className='b-b-0' vertical>
                <Dimmer inverted active={(copyId || draftId) && step === 0} className={'copy-dimmer'}>
                    <Loader label={'Загрузка данных'} description={copyId && 'Идет копирование'}/>
                </Dimmer>
                <Addresses
                    errors={errors || {}}
                    isCalc={isCalc}
                    isCalcV2={isCalcV2}
                    isTanderCalc={isTanderCalc}
                    label={step <= 0}
                    form={form}
                    onChange={handleAddressSelect}
                    companyId={companyId}
                    setCompanyId={setCompanyId}
                    parcelTypes={parcelTypes}
                    customBlock={step === -1 && <SetCompanyBlock
                        companyId={companyId}
                        onChange={(value) => {
                            setCompanyId(value);
                            setStep(0);
                        }}
                    />}
                />
            </Segment>
            <Step
                weekdays={weekdays}
                loading={loadingTariffs}
                step={step}
                form={form}
                setStep={setStep}
                changeForm={changeForm}
                changeParams={changeParamsForm}
                onClick={onPickUp}
                tariffs={tariffs}
                deliveryTypes={deliveryTypes}
                companyId={companyId}
                resetData={resetData}
                companyData={companyData}
                onChangeAddress={handleAddressSelect}
                createParcel={createParcel}
                loadingCreate={loadingCreate}
                services={services}
                errors={errors || {}}
                parcelTypes={parcelTypes}
                isCalc={isCalc}
                isCalcV2={isCalcV2}
                isTanderCalc={isTanderCalc}
                calcByPlacesOn={calcByPlacesOn}
                setCalcByPlacesOn={setCalcByPlacesOn}
                saveDraftBtn={!isCalc && saveDraftBtn}
                setErrors={(errors) => setPayerTabErrors(errors)}
                payerValidateRef={payerValidateRef}
                initData={initForm}
                getValueDeclaredDisabled={getValueDeclaredDisabled}
                insuranceCostIsNull={insuranceCostIsNull}
                hasPvzCdekCarrier={hasPvzCdekCarrier}
                showExtraServices={!isCalc && !!companyData.showExtraServices}
            />
            {confirmModal && <ConfirmModal
                open={confirmModal.open}
                label={confirmModal.label}
                setOpen={() => setConfirmModal(null)}
                onConfirm={confirmModal.onConfirm}
                onClose={confirmModal.onClose}
                children={confirmModal.children}
                confirmBtnLabel={confirmModal.confirmBtnLabel}
                hideConfirm={confirmModal.hideConfirm}
                closeBtnLabel={confirmModal.closeBtnLabel}
                hideClose={confirmModal.hideClose}
            />}
            <Prompt when={!!draftId && (step > 3) && !isSaved}
                    message="Вы действительно хотите перейти? Введенная вами информация не будет сохранена."
            />
        </div>
    );
};

export default CreateParcelForm;



// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/createParcelForm.jsx